import GC from '@grapecity/spread-sheets';
import i18nCommon from '@/i18ns/vi/i18nCommon';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import popupUtil from '@/commons/popupUtil.js';
import explanationFormModelListTypeAPI from '@/apis/di/explanationFormModelListTypeAPI';
import dictionaryPresentAPI from '@/apis/di/dictionaryPresentAPI';
import explanationFormModelAPI from '@/apis/di/explanationFormModelAPI';
import { useToast } from 'vue-toast-notification';
import { workbookHelper } from '@/commons/workbook/workbookHelper.js';
import ExcelJS from 'exceljs';
import moment from 'moment';
import { MSConstant } from '@/commons/wildcards';

class MISAExplanationFormHelper {
  /**
   * tìm key trường dữ liệu theo value (áp dụng chuyển đổi qua lại với Enum ko có giá trị trường giống nhau)
   * @param {object} obj đối tượng
   * @param {} value giá trị của 1 trường của đối tượng
   * @returns key của trường có giá trị tương ứng
   */
  findKeyByValue(obj, value) {
    return Object.keys(obj).find(key => obj[key] === value);
  }
  /**
   * chuyển đổi giá trị giữa 2 đối tượng cùng bộ property
   * @param {} value giá trị cần chuyển đổi
   * @param {object} objLastValue đối tượng chứa giá trị cần chuyển đổi
   * @param {object} objNewValue  chứa giá trị muốn biến đổi thánh
   * @returns
   */
  typeDataNumberToString(value, objLastValue, objNewValue) {
    let key = this.findKeyByValue(objLastValue, value);
    if (key) {
      return objNewValue[key];
    }
  }

  typeToNumber(value) {
    if (!value) {
      return 0;
    }
    return this.typeDataNumberToString(value, i18nEnum.ExplanModeDataType, i18nEnum.ExplanModeDataTypeNumber);
  }

  typeToString(value) {
    if (!value) {
      return '';
    }
    return this.typeDataNumberToString(value, i18nEnum.ExplanModeDataTypeNumber, i18nEnum.ExplanModeDataType);
  }

  /**
   * tạo câu lệnh if hoàn chỉnh từ các biểu thức điều kiện nhỏ
   * @param {array} arr Danh sách điều kiện IF arr = ['a', 'b', 'c', 'd', 'e'];
   * @param {} type kiểu dữ liệu trường;
   * @returns câu lệnh IF hoàn chỉnh Output: IF(a, IF(b, IF(c, IF(d, IF(e)))))
   * created Tvtam 06.03.2024
   */
  createNestedIfStatement(arr, type) {
    let nestedIf = '';
    for (let i = arr.length - 1; i >= 0; i--) {
      if (i === arr.length - 1) {
        let data = 0;
        switch (type) {
          case i18nEnum.ExplanModeDataType.Number:
          case i18nEnum.ExplanModeDataType.Amount:
          case i18nEnum.ExplanModeDataType.Percent:
          case i18nEnum.ExplanModeDataType.Constant:
          case i18nEnum.ExplanModeDataType.Boolean:
            data = 0;
            break;
          default:
            data = '""';
            break;
        }
        nestedIf = `IF(${arr[i]},${data})`;
      } else {
        nestedIf = `IF(${arr[i]}, ${nestedIf})`;
      }
    }
    switch (type) {
      case i18nEnum.ExplanModeDataType.Number:
      case i18nEnum.ExplanModeDataType.Amount:
      case i18nEnum.ExplanModeDataType.Percent:
      case i18nEnum.ExplanModeDataType.Constant:
      case i18nEnum.ExplanModeDataType.Boolean:
        return `IFERROR(${nestedIf},0)`;
      default:
        return `IFERROR(${nestedIf},"")`;
    }
  }

  /**
   * Hàm chuyển số sang chữ phục vụ Gen công thức excel
   * @param {int} n số
   * @returns chữ tương ứng
   * created Tvtam 06.03.2024
   */
  mapNumberToLetter(n) {
    n += 1;
    let column = '';
    while (n > 0) {
      let remainder = (n - 1) % 26;
      column = String.fromCharCode(65 + remainder) + column;
      n = Math.floor((n - 1) / 26);
    }
    return column;
  }

  /**
   * Hàm chuyển chữ sang số A -> 0
   * @param {int} number số
   * @returns chữ tương ứng
   * created Tvtam 18.03.2024
   */
  mapCharCodeToNumber(column) {
    let number = 0;
    for (let i = 0; i < column.length; i++) {
      number = number * 26 + (column.charCodeAt(i) - 65 + 1);
    }
    return number - 1;
  }

  //=IF(OR(D2<89,D2>113),"A",IF(D2=100,"C"))
  //
  /**
   * Gen công thức
   * @param {array} listFieldModel danh sách trường dữ liệu
   * @param {array} listCondition danh sách điều kiện
   * @param {array} fieldNotUses danh sách trường không thực hiện gen điều kiện
   * @param {} type kiểu dữ liệu trường
   * @returns
   */
  genFormulaConditionExcel(listCondition, fieldNotUses, type) {
    let formulas = [];
    let me = this;
    listCondition.forEach(function (element) {
      formulas.push(me.genConditionIfExcel(element, fieldNotUses, 'DefaultValue', type));
    });
    return this.createNestedIfStatement(formulas, type);
  }
  /**
   * Thay thế all
   * @param {*} str
   * @param {*} find
   * @param {*} replace
   * @returns
   */
  replaceAll(str, find, replace) {
    return str.split(find).join(replace);
  }
  /**
   * Gen điều kiện AND và OR
   * @param {object} obj Đối tượng chứa điều kiện
   * @param {array} arrNotCondition danh sách các trường trong đối tượng không dùng để để so sánh
   * @param {string} fieldValue tên trường lấy dữ liệu
   * @returns string : AND(OR(E2>1),OR(D2<89,D2>113)),"A",IF(D2=100,"C")
   * created Tvtam 06.03.2024
   */
  genConditionIfExcel(obj, arrNotCondition, fieldValue, type) {
    switch (type) {
      case i18nEnum.ExplanModeDataType.Number:
      case i18nEnum.ExplanModeDataType.Amount:
      case i18nEnum.ExplanModeDataType.Percent:
      case i18nEnum.ExplanModeDataType.Constant:
      case i18nEnum.ExplanModeDataType.Boolean:
        return `AND(OR(${Object.entries(obj)
          .filter(([key]) => !arrNotCondition.includes(key))
          .map(([key, values]) => values.map(value => `[${key}]="${value ? this.replaceAll(value, '"', "'") : ''}"`).join(','))
          .join('),OR(')})),${obj[fieldValue] ? obj[fieldValue] : 0}`;
      default:
        return `AND(OR(${Object.entries(obj)
          .filter(([key]) => !arrNotCondition.includes(key))
          .map(([key, values]) => values.map(value => `[${key}]="${value ? this.replaceAll(value, '"', "'") : ''}"`).join(','))
          .join('),OR(')})),"${obj[fieldValue] ? this.replaceAll(obj[fieldValue], '"', "'") : ''}"`;
    }
  }

  /**
   * Chuyển từ công thức hệ thống sang công thức excel
   * @param {string} stringFormula Chuỗi công thức lưu ở Database
   * @param {array} listFieldModel Danh sách các trường dữ liệu của mẫu thuyết minh
   * @param {number} [indexRow=0] số dòng
   * @returns công thức excel đã được chuẩn hóa
   * created Tvtam : 06.03.2024
   */
  genFormulaExcel(stringFormula, listFieldModel, indexRow = 1, typeFormula, dataList = null, data_type = null) {
    let me = this,
      generalFields = i18nEnum.ExplanatoryGeneralFields;

    stringFormula = stringFormula.trim();
    //Lấy ra các trường dữ liệu được sử dụng trong công thức
    let matches = stringFormula.match(/\[.*?\]/g);

    if (matches?.length > 0) {
      //Lọc những giá trị trùng nhau
      matches = [...new Set(matches)];
      let value = '';

      //Thay thế bằng địa chỉ cột
      listFieldModel.filter(t => matches.includes(`[${t.field_code}]`))
        .forEach(function (element) {
          value = me.mapNumberToLetter(element.sort_order) + indexRow.toString();
          stringFormula = me.replaceAll(stringFormula, `[${element.field_code}]`, value);
        });

      //Thay thế các trường thông tin chung
      generalFields.filter(t => matches.includes(`[${t.FieldCode}]`)).forEach(function (element) {
        value = element.FieldCode;
        stringFormula = me.replaceAll(stringFormula, `[${element.FieldCode}]`, value);
      });
    }

    if (!typeFormula == i18nEnum.DefaultTypeNumber.ValueToCondition && Number(stringFormula)) {
      stringFormula = `IFERROR(${stringFormula},0)`;
    }
    switch (data_type) {
      case i18nEnum.ExplanModeDataType.Number:
      case i18nEnum.ExplanModeDataType.Amount:
      case i18nEnum.ExplanModeDataType.Percent:
      case i18nEnum.ExplanModeDataType.Constant:
      case i18nEnum.ExplanModeDataType.Boolean:
        return `IFERROR(${stringFormula},0)`;
      default:
        return `IFERROR(${stringFormula},"")`;
    }
  }

  /**
   *Map giá trị tương ứng với mã của đối tượng
   * @param {*} datasEntity
   * @param {*} dataMap
   */
  mapValueByCodeEntity(datasEntity, dataMap) {
    let me = this;
    datasEntity.forEach(function (element) {
      dataMap = me.replaceAll(dataMap, element.code, element.value);
    });
    return dataMap;
  }
  /**
   * Gen công thức excel từ công thức
   * @param {*} wb workbook
   * @param {*} listFieldModel danh sách trường thuyết minh
   * created Tvtam : 07.03.2024
   */
  async attachFormulaDefault(wb, listFieldModel) {
    let dataList = await explanationFormModelListTypeAPI.GetDataByListExplanaFormModel({
      explanaModelIds: listFieldModel
        .filter(obj => obj.data_type === i18nEnum.ExplanModeDataType.List)
        .map(obj => obj.explanation_form_model_id),
    });
    await listFieldModel.forEach(item => {
      if (item.default_type && item.default_type != null) {
        switch (item.default_type) {
          case i18nEnum.DefaultTypeNumber.FixedValue:
            if (item.default_value && item.default_value != null) {
              let stringFormula = item.default_value;
              if (Number(stringFormula)) {
                stringFormula = `${stringFormula}`;
              } else {
                stringFormula = `"${stringFormula}"`;
              }

              this.attachFormulaToWorkbook(wb, item.sort_order, stringFormula);
            }
            break;
          case i18nEnum.DefaultTypeNumber.ValueToFormula:
            if (item.default_value && item.default_value != null) {
              this.attachFormulaToWorkbook(
                wb,
                item.sort_order,
                this.genFormulaExcel(item.default_value, listFieldModel, 1, item.default_type, null),
              );
            }
            break;
          case i18nEnum.DefaultTypeNumber.ValueToCondition:
            if (item.default_value && item.default_value != null && item.is_setting_default_value) {
              this.attachFormulaToWorkbook(
                wb,
                item.sort_order,
                this.genFormulaExcel(
                  this.genFormulaConditionExcel(
                    JSON.parse(item.default_value),
                    ['DefaultValue', 'IsEdit'],
                    item.data_type,
                  ),
                  listFieldModel,
                  1,
                  item.default_type,
                  dataList,
                  item.data_type,
                ),
              );
            }
        }
      }
    });
  }
  /**
   * Gán công thức lên workbook
   * @param {workBook} wb
   * @param {int} indexColumn số cột
   * @param {string} formula công thức excel
   * created Tvam 06.03.2024
   */
  attachFormulaToWorkbook(wb, indexColumn, formula) {
    if (formula.toString() && formula.toString().trim() !== '') {
      try {
        wb.getActiveSheet().setFormula(0, indexColumn, formula.toString());
      } catch { }
    }
  }

  /**
   *
   * @param {Giá trị để lọc } valueParent
   * @param {*} dataFieldInfor
   * @param {thông tin cell của combobox lọc} indexChild
   * @returns
   * create by tvtam 04.03.2024
   */
  updateDataComboboxWorkbookByValueParent(valueParent, dataFieldInfor, indexChild) {
    let data = JSON.parse(dataFieldInfor[indexChild].data_value);
    return data.filter(obj => obj.c === valueParent);
  }
  /**
   * dataSource cho workbook
   *@param {workbook} wb
   * @param {array} dataSource
   * create by tvtam 04.03.2024
   */

  renderWorkbookByDataSource(wb, dataSource) {
    wb.getActiveSheet().setDataSource(dataSource);
  }
  /**
   * Custom thông tin dòng
   * @param {workBook} wb
   * @param {array} colInfos thông tin của cột
   * create by tvtam 04.03.2024
   */
  async bindingheaderColumns(wb, colInfos) {
    colInfos = await colInfos;
    if (colInfos && colInfos.length !== 0) {
      wb.getActiveSheet().bindColumns(colInfos);
    }
  }
  /**
   * Hàm hỗ trợ sinh dataSoruce cho mẫu người dùng nhập
   * @param {array} dataListField danh sách trường dữ liệu của biểu thuyết minh
   * @returns DataSoure rỗng để set cho workbook
   * create by tvtam 04.03.2024
   */
  genDataDefault(dataListField) {
    let dataSources = [];
    let dataSource = {};
    if (!dataListField || dataListField == null || dataListField.length <= 0) {
      return dataSources;
    }
    dataListField.forEach(function (element) {
      switch (element.data_type) {
        case i18nEnum.ExplanModeDataType.Number:
        case i18nEnum.ExplanModeDataType.Amount:
        case i18nEnum.ExplanModeDataType.Percent:
        case i18nEnum.ExplanModeDataType.Constant:
        case i18nEnum.ExplanModeDataType.Boolean:
          dataSource[element.field_code] = 0;
          break;
        default:
          dataSource[element.field_code] = '';
          break;
      }
    });
    dataSources.push(dataSource);
    return dataSources;
  }

  /**
   * Hàm hỗ trợ sinh đầy đủ bao thông tin cột cho mẫu người dùng nhập (bao gồm cellType) áp dụng để sinh lại toàn bộ mẫu
   * @param {Array} dataListField Danh sách trường dữ liệu
   * @returns danh sách thông tin cột
   * create by tvtam 04.03.2024
   *  5-Số tiền, 10-Chữ, 15-Ngày tháng, 20-Đúng sai, 25-Số, 30-Tỉ lệ, 35-Danh sách',
   */
  async genInforColumns(dataListField) {
    const me = this;
    let colInfos = [];
    let dataList = await explanationFormModelListTypeAPI.GetDataByListExplanaFormModel({
      explanaModelIds: dataListField
        .filter(obj => obj.data_type === i18nEnum.ExplanModeDataType.List)
        .map(obj => obj.explanation_form_model_id),
    });

    if (dataListField && dataListField.length > 0) {
      dataListField.forEach(element => {
        let isEdit = !element.is_edit && element.is_setting_default_value ? false : true;
        let column = {
          name: element.field_code,
          displayName: element.is_required ? element.field_name + '*' : element.field_name,
          formatter: element.format,
          visible: element.is_hide_show,
          size: me.getFitWidthColumn(element.field_name),
          data_type: me.typeToNumber(element.data_type),
          sort_order: element.sort_order,
          is_required: element.is_required,
          isNotEdit: !isEdit,
        };

        switch (element.data_type) {
          // kiểu danh sách Boolean
          case i18nEnum.ExplanModeDataType.List:
            const combo = new GC.Spread.Sheets.CellTypes.ComboBox();
            combo.items(
              dataList
                .filter(obj => obj.explanation_form_model_id === element.explanation_form_model_id)
                .map(obj => ({ text: this.replaceAll(obj.value, '"', "'"), value: obj.code })),
            );
            column.cellType = combo;
            if (element.is_filter) {
              column.is_filter = true;
              column.default_filter = JSON.parse(element.default_filter);
            }
            column.formatter = i18nEnum.ExplanModeFormatter.Text;
            break;
          // kiểu check box
          case i18nEnum.ExplanModeDataType.Boolean:
            const checkbox = new GC.Spread.Sheets.CellTypes.CheckBox();
            column.cellType = checkbox;
            break;
          // Kiểu số
          case i18nEnum.ExplanModeDataType.Amount:
          case i18nEnum.ExplanModeDataType.Number:
            column.formatter = i18nEnum.ExplanModeFormatter.Number;
            break;
          case i18nEnum.ExplanModeDataType.Percent:
            column.formatter = i18nEnum.ExplanModeFormatter.Percent;
            break;
          case i18nEnum.ExplanModeDataType.Date:
            column.formatter = i18nEnum.ExplanModeFormatter.Date;
            break;
          case i18nEnum.ExplanModeDataType.Constant:
            column.formatter = i18nEnum.ExplanModeFormatter.Constant;
            break;
          default:
            column.formatter = i18nEnum.ExplanModeFormatter.Text;
            break;
        }
        // xử lý với default value(bảng điều kiện)
        switch (element.default_type) {
          case i18nEnum.DefaultTypeNumber.ValueToCondition:
            column.default_value = element.default_value;
            break;
        }
        // Xử lý add comment
        if (this.genCommentColumn(element, dataListField)) {
          column.commentCol = this.genCommentColumn(element, dataListField);
        }
        colInfos.push(column);
      });
    }
    return colInfos;
  }
  /**
   * Hàm check change workbook
   * @param {workBook} wb
   * create by tvtam 04.03.2024
   */
  hasChangeWorkbook(wb) {
    if (wb && wb.undoManager()?.Nmt?.length > 0) {
      return true;
    }
    return false;
  }
  /**
   * Hàm xóa sự thay đổi của workbook
   * @param {*} wb
   */
  clearChangeWorkbook(wb) {
    while (wb.undoManager().Nmt.length > 0) {
      wb.undoManager().undo();
    }
  }

  /**
   *
   * @param {*} wb
   * @param {hành động trên toolbarFull} command
   * @param {Giá trị set trên workbook} valueItem
   */
  commandClickActionToolBarWb(wb, command, valueItem) {
    let me = this,
      sheetActive = wb.getActiveSheet();
    //wbAction = GC.Spread.Sheets.Designer;

    const getRange = () => {
      const activeSheet = wb.getActiveSheet(),
        [selection] = activeSheet.getSelections();

      if (selection) {
        const { row, col, rowCount, colCount } = selection;
        const range = activeSheet.getRange(row, col, rowCount, colCount);
        return range;
      }
    };
    //Xử lý với command tương ứng
    switch (command) {
      case i18nCommon.command.ExpandCollapse:
        var complete = () => {
          if (wb) {
            wb.refresh();
            wb.hideLoading(wb.element);
          }
        };
        wb.showLoading(wb.element);
        var sheet = item.parents('.worksheet-container');
        if (item.hasClass('expanded')) {
          item.removeClass('expanded');
          sheet.find('.ws-content-detail').slideDown(200, function () {
            complete();
          });
          sheet.find('.worksheet-content').removeClass('expanded');
          sheet.parent().siblings('.ui-dialog-titlebar').removeClass('height-40');
        } else {
          item.addClass('expanded');
          sheet.find('.ws-content-detail').slideUp(200, function () {
            complete();
          });
          sheet.find('.worksheet-content').addClass('expanded');
          sheet.parent().siblings('.ui-dialog-titlebar').addClass('height-40');
        }

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.FontFamily:
        // var italicValue = !item.hasClass('active') ? 'italic' : 'normal';
        // me.setActiveCommandToolbar(item);
        getRange().fontFamily(valueItem.newData.fontValue);

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.FontSize:
        // var italicValue = !item.hasClass('active') ? 'italic' : 'normal';
        // me.setActiveCommandToolbar(item);
        getRange().fontSize(valueItem.newData.valueSize + 'pt');

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.Italic:
        // var italicValue = !item.hasClass('active') ? 'italic' : 'normal';
        // me.setActiveCommandToolbar(item);
        // wbAction.setFontStyle(wb, italicValue);
        getRange().fontStyle('italic');

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.Bold:
        // var boldValue = !item.hasClass('active') ? 'bold' : 'normal';
        // me.setActiveCommandToolbar(item);
        // wbAction.setFontWeight(wb, boldValue);
        getRange().fontWeight('bold');

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.Underline:
        // var isUnderline = !item.hasClass('active');
        // me.setActiveCommandToolbar(item);
        // wbAction.setUnderline(wb, isUnderline);
        getRange().fontStyle('underline');

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.Wordwrap:
        var isWordwrap = !item.hasClass('active');
        me.setActiveCommandToolbar(item);
        wbAction.setWordWrap(wb, isWordwrap);

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.Indent:
      case i18nCommon.command.Outdent:
        wbAction.setIndent(wb, command === 'indent' ? 1 : -1);

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.HalignLeft:
      case i18nCommon.command.HalignCenter:
      case i18nCommon.command.HalignRight:
      case i18nCommon.command.ValignTop:
      case i18nCommon.command.ValignCenter:
      case i18nCommon.command.ValignBottom:
        var aligns = command.split('-');
        if (aligns[0] === 'halign') {
          wbAction.setHAlign(wb, GC.Spread.Sheets.HorizontalAlign[aligns[1]]);
        } else {
          wbAction.setVAlign(wb, GC.Spread.Sheets.VerticalAlign[aligns[1]]);
        }
        me.setActiveCommandToolbar(item);

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.CommentExcel:
        if (item.hasClass('ic-comment')) {
          wbAction.insertComment(wb);
        } else {
          wbAction.deleteComment(wb);
        }

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.FreezePanel:
        const activeCol = sheetActive.getActiveColumnIndex(),
          activeRow = sheetActive.getActiveRowIndex();
        var value = {
          col: activeCol !== 0 ? activeCol : 0,
          row: activeRow !== 0 ? activeRow : 0,
        };
        wbAction.freeze(wb, value);

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.Unfreeze:
        wbAction.unfreeze(wb);
        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.Cellmerge:
        if (!item.hasClass('active')) {
          wbAction.mergeCells(wb);
        } else {
          wbAction.unmergeCells(wb);
        }

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.ForeColor:
        var foreColor = item.find('~ .color-cell-value').css('background-color');
        wbAction.setForeColor(wb, foreColor || 'black');

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.BackColor:
        var backColor = item.find('~ .color-cell-value').css('background-color');
        wbAction.setBackColor(wb, backColor || 'white');

        //Gán cờ checkchange
        sheetActive.hasChange = true;
        break;
      case i18nCommon.command.Import:
        MISAMessageBox.info('', MISA.Resources.BaseList.OnWorking);
        break;

      case i18nCommon.command.AddOneDecimalNumber:
        {
          const range = getRange();
          if (range) {
            const formatter = range.formatter();
            if (typeof formatter === 'string' && formatter !== 'General') {
              //DTHieu1 29.07.2022: Sửa sử dụng hàm của SpreadSheet
              wbAction.increaseDecimal(wb);
            }
            // dành cho trường hợp thay đổi format bằng tay trên mẫu biểu
            else if (typeof formatter === 'object' && formatter.formatCached && formatter.formatCached !== 'General') {
              const regex = new RegExp(MISA.Constants.Regex.ThousandSeperatorExcel);

              if (regex.test(formatter.formatCached)) {
                const decimalRegex = new RegExp(MISA.Constants.Regex.DecimalSeperatorExcel);
                let newFormatter = '';
                if (decimalRegex.test(formatter.formatCached)) {
                  newFormatter = `${formatter.formatCached}0`;
                } else {
                  newFormatter = `${formatter.formatCached}.0`;
                }

                range.formatter(newFormatter);
              }
            }
          }
        }
        break;
      case i18nCommon.command.DeleteOneDecimalNumber:
        {
          const range = getRange();
          if (range) {
            const formatter = range.formatter();
            if (typeof formatter === 'string' && formatter !== 'General') {
              //DTHieu1 29.07.2022: Sửa sử dụng hàm của SpreadSheet
              wbAction.decreaseDecimal(wb);
            }
            // dành cho trường hợp thay đổi format bằng tay trên mẫu biểu
            else if (typeof formatter === 'object' && formatter.formatCached && formatter.formatCached !== 'General') {
              const regex = new RegExp(MISA.Constants.Regex.ThousandSeperatorExcel);

              if (regex.test(formatter.formatCached)) {
                const decimalRegex = new RegExp(MISA.Constants.Regex.DecimalSeperatorExcel);
                if (decimalRegex.test(formatter.formatCached)) {
                  let newFormatter = formatter.formatCached.slice(0, -1);
                  if (newFormatter.endsWith(MISA.Constants.ExcelFormatter.NumberDecimalSeperatorFormat)) {
                    newFormatter = newFormatter.slice(0, -1);
                  }
                  range.formatter(newFormatter);
                }
              }
            }
          }
        }
        break;
      case i18nCommon.command.BorderBottom:
      case i18nCommon.command.BorderTop:
      case i18nCommon.command.BorderLeft:
      case i18nCommon.command.BorderRight:
      case i18nCommon.command.BorderNone:
      case i18nCommon.command.BordersAll:
      case i18nCommon.command.BorderOutside:
      case i18nCommon.command.BorderThickOutside:
      case i18nCommon.command.BorderDoubleBottom:
      case i18nCommon.command.BorderThickBottom:
      case i18nCommon.command.BorderTopAndBottom:
      case i18nCommon.command.BorderTopAndThickBottom:
      case i18nCommon.command.BorderTopAndDoubleBottom:
        var mod = item.parent('li').data('value');
        if (mod) {
          var borderOption = MISAWorkbookHelper.selectionBorderType(mod) ?? [];
          wbAction.setBorder(wb, borderOption[0]);
        }
        break;
      case i18nCommon.command.Undo:
        wb.undoManager().undo();
        break;
      case i18nCommon.command.Redo:
        wb.undoManager().redo();
        break;
      default:
        MISAMessageBox.info('', MISA.Resources.BaseList.OnWorking);
        break;
    }
  }
  /**
   * Xuất khẩu mẫu tổng hợp bao gồm chân chữ ký và tiêu đề
   * Created by tvtam 21.12.2023
   *
   * */
  async exportFullTemplate(wb, fileName, sysExplanationFormId) {
    const activeSheet = wb.getActiveSheet(),
      currentProtectedStatus = activeSheet.options.isProtected; // lưu lại trạng thái protect sheet hiện tại
    try {
      this.handleAssignSignature(wb, true, () => { });
      activeSheet.options.isProtected = false;

      const jsonFile = wb.toJSON({ includeBindingSource: true }),
        IO = new GC.Spread.Excel.IO();

      IO.save(jsonFile, async blob => {
        const file = new File([blob], fileName ? `${fileName}.xlsx` : 'bieu_mau_ban_hanh.xlsx');

        const form = new FormData(),
          config = {
            data: form,
            contentType: false,
            cache: false,
            enctype: 'multipart/form-data',
            processData: false,
          };
        form.append('file', file);
        form.append('SysExplanationFormId', sysExplanationFormId);
        form.append('Upload_file', true);

        const url = MISAUtil.getServiceUrl(
          MISA.Enumeration.MicroserviceType.Core,
          'DownloadEstimate',
          'CustomTemplateForm',
        );
        const res = await AjaxAsync(url, config, null);
        if (res.Status === MISA.Enumeration.ServiceStatus.Success && res.Data) {
          var atobData = window.atob(res.Data);
          var uInt8Array = new Uint8Array(atobData.length);
          for (var i = 0; i < atobData.length; ++i) {
            uInt8Array[i] = atobData.charCodeAt(i);
          }
          const blob = new Blob([uInt8Array], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          const urlBlob = window.URL.createObjectURL(blob),
            a = document.createElement('a');
          a.href = urlBlob;
          a.download = fileName ? `${fileName}.xlsx` : 'bieu_mau_ban_hanh';
          a.click();
          window.URL.revokeObjectURL(urlBlob);
        }
      });
    } catch (e) {
      MISAUtil.handlerLog(e);
      MISAMessageBox.toastrError(MISA.Resources.MessageBox.ExceptionMessage);
    } finally {
      activeSheet.options.isProtected = currentProtectedStatus;
    }
  }

  /**
   *  xuất khẩu biểu mẫu
   * @param {*} wb
   * @param {*} nameFile tên file
   * @param {*} type định dạng file (xlsx,ssjosn,sjs,csv)
   * @param {*} printHeader Có xuất khẩu cả tiêu đề cột không
   * create by tvtam 09.01.2024
   */
  exportSetUpForm(
    wb,
    nameFile = 'export',
    fileType = 'sjs',
    options,
    callbackAfterCreatFile,
    callbackError,
    printHeader = false,
  ) {
    let me = this;
    options = {
      includeBindingSource: true,
      includeStyles: true,
      includeFormulas: true,
      saveAsView: true,
      includeUnusedNames: true,
    };
    if (printHeader) {
      options = {
        includeBindingSource: true,
        includeStyles: true,
        includeFormulas: true,
        saveAsView: true,
        includeUnusedNames: true,
        columnHeadersAsFrozenRows: true,
      };
    }
    if (fileType === 'sjs') {
      wb.save(
        function (blob) {
          // saveAs(blob, nameFile + '.' + fileType);
          callbackAfterCreatFile(blob);
        },
        function () {
          callbackError();
        },
        options,
      );
    } else {
      wb.export(
        async function (blob) {
          let updateBlods = await me.removeSheetFromBlob(blob, 'Evaluation Version', printHeader);
          saveAs(updateBlods, nameFile + '.' + fileType);
          callbackAfterCreatFile(blob);
        },
        function () {
          callbackError();
        },
        options,
      );
    }
  }
  /**
   * Xóa sheet từ Blob Excel.
   * @param {Blob} blob - Blob chứa dữ liệu Excel.
   * @param {string} sheetNameToRemove - Tên sheet cần xóa.
   * @param {boolean} mode -Có custom lại style workbook trước khi save ko.
   * @returns {Promise<Blob>} - Blob mới sau khi sheet bị xóa.
   */
  async removeSheetFromBlob(blob, sheetNameToRemove, mode = false) {
    // Chuyển Blob thành ArrayBuffer
    const arrayBuffer = await blob.arrayBuffer();

    // Sử dụng ExcelJS để xử lý workbook
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(arrayBuffer);
    // Xóa sheet dựa trên tên
    const sheet = workbook.getWorksheet(sheetNameToRemove);
    if (sheet) {
      workbook.removeWorksheet(sheet.id); // Xóa sheet
    }
    if (mode) {
      this.updateFontInWorkbook(workbook);
    }
    // Chuyển workbook đã chỉnh sửa thành buffer
    const updatedBuffer = await workbook.xlsx.writeBuffer();

    // Tạo Blob mới từ buffer
    const updatedBlob = new Blob([updatedBuffer], { type: blob.type });
    return updatedBlob;
  }

  /**
   * Hàm tạo file lưu mẫu
   * @param {*} wb
   * @param {*} callbackAfterCreatFile
   * @returns
   */
  createFileSave(wb, callbackAfterCreatFile) {
    if (!wb) {
      return;
    }
    let template = JSON.stringify(wb.getActiveSheet().toJSON());
    if (callbackAfterCreatFile && typeof callbackAfterCreatFile === 'function') callbackAfterCreatFile(template);
  }
  /**
   * Render cho workbook có 1 sheet
   * @param {*} wb
   * @param {*} data
   */
  renderWorkbookByJson(wb, data) {
    let me = this;
    wb.suspendPaint();
    wb.suspendEvent();
    wb.options.tabEditable = true;
    wb.options.allowCopyPasteExcelStyle = true;
    wb.options.allowExtendPasteRange = true;
    // nếu có nhiều hơn 1 sheet thì xóa loại bỏ các sheet thừa đi
    while (wb.getSheetCount() > 1) {
      wb.removeSheet(1);
    }
    wb.setActiveSheet(wb.getSheet(0).name());
    try {
      let activeSheet = wb.getActiveSheet();
      activeSheet.reset();
      if (data) {
        activeSheet.fromJSON(data, {
          doNotRecalculateAfterLoad: true,
        });
      } else {
        activeSheet.fromJSON(
          {},
          {
            doNotRecalculateAfterLoad: true,
          },
        );
      }

      activeSheet.isPaintSuspended(false);
      activeSheet.repaint();
      //Gán lại tên sheet
      let sheetName =
        activeSheet.name() === 'undefined' || !activeSheet.name()
          ? i18nEnum.WorkbookEnum.DefaultSheetName
          : activeSheet.name();
      activeSheet.name(sheetName);
    } catch {
      activeSheet.fromJSON(
        {},
        {
          doNotRecalculateAfterLoad: true,
        },
      );
    } finally {
      wb.resumeEvent();
      wb.resumePaint();
      me.resetSelectCellWorkbook(wb);
    }
  }
  /**
   * Hàm mở workbook bằng file
   * @param {*} file
   * @param {*} option
   * @param {*} successOpen
   * @param {*} errorOpen
   */
  openFileToform(file, option, successOpen, errorOpen) {
    let wb = new GC.Spread.Sheets.Workbook();
    let fileType = file.name.split('.').pop();
    if (fileType === 'sjs') {
      wb.open(
        file,
        function () {
          successOpen(wb);
          return wb.toJSON();
        },
        function () {
          errorOpen();
        },
        option,
      );
    } else {
      wb.import(
        file,
        function () {
          successOpen(wb);
          return wb.toJSON();
        },
        function () {
          errorOpen();
        },
        option,
      );
    }
  }

  /**
   * Copy/Cut/Paste custom ở menuContext workbook Speadjs
   * @param {any} spread : workBook
   * @param {any} commandAction: Text Command Action
   * created by Tvtam 06.12.2023
   */
  contextMenuCommandCustom(spread, commandAction) {
    var sheet = spread.getActiveSheet();

    // Get selected range
    var selection = sheet.getSelections()[0];
    if (selection) {
      var row = selection.row;
      var col = selection.col;
      var rowCount = selection.rowCount;
      var colCount = selection.colCount;
      let cellType = null;
      let cell = null;
      switch (commandAction) {
        case 'copy':
          var copiedData = sheet.getArray(row, col, rowCount, colCount);
          this.copyToClipboard(copiedData, row, col, rowCount, colCount, sheet, false);
          break;

        case 'cut':
          var cutData = sheet.getArray(row, col, rowCount, colCount);
          this.copyToClipboard(cutData, row, col, rowCount, colCount, sheet, true);
          break;

        case 'paste':
          if (sheet.getCell(row, col).locked() && sheet.options.isProtected) {
            return;
          }
          this.pasteFromClipboard(sheet, row, col);
          break;
        case 'combobox':
          cellType = new GC.Spread.Sheets.CellTypes.ComboBox();
          cellType.items([
            { text: i18nEnum.ReportExcelFieldTypeText.Empty, value: i18nEnum.ReportExcelFieldTypeText.Empty },
            { text: i18nEnum.ReportExcelFieldTypeText.Summary, value: i18nEnum.ReportExcelFieldTypeText.Summary },
            { text: i18nEnum.ReportExcelFieldTypeText.Count, value: i18nEnum.ReportExcelFieldTypeText.Count },
            { text: i18nEnum.ReportExcelFieldTypeText.Average, value: i18nEnum.ReportExcelFieldTypeText.Average },
            { text: i18nEnum.ReportExcelFieldTypeText.Concat, value: i18nEnum.ReportExcelFieldTypeText.Concat },
          ]);
          cell = sheet.getCell(row, col);
          cellType.editorValueType(GC.Spread.Sheets.CellTypes.EditorValueType.value);
          cell.value(i18nEnum.ReportExcelFieldType.Summary);
          cell.text(i18nEnum.ReportExcelFieldTypeText.Summary);
          cell.cellType(cellType);
          break;
        case 'text':
          cellType = new GC.Spread.Sheets.CellTypes.Text();
          cell = sheet.getCell(row, col, GC.Spread.Sheets.SheetArea.viewport);
          cell.cellType(cellType);
          break;
      }
    }
  }

  /**
   * hàm thực hiện đếm xem có bao nhiêu dòng có tag name trong sheet
   */
  countIsDetailSheet(wb, tagName) {
    var sheet = wb.getActiveSheet();
    // Đếm số dòng có tag là isDetail
    var rowCount = sheet.getRowCount();
    var detailRowCount = 0;

    for (var i = 0; i < rowCount; i++) {
      var tag = sheet.getTag(i, -1);
      if (tag && tag[tagName]) {
        detailRowCount++;
      }
    }
    return detailRowCount;
  }

  /**
   * hàm kiểm tra xem giá trị lớn nhất của cụm trong sheet
   */
  checkIdCumInSheet(wb) {
    var sheet = wb.getActiveSheet();
    var rowCount = sheet.getRowCount();
    var maxIdCum = 0;
    for (var i = 0; i < rowCount; i++) {
      var tag = sheet.getTag(i, -1);
      if (tag && tag.idCum) {
        if (tag.idCum > maxIdCum) {
          maxIdCum = tag.idCum;
        }
      }
    }
    return maxIdCum + 1;
  }

  /**
   * Copy/cut từ sheet của spreadjs vào bộ nhớ tạm của trình duyện
   * @param {any} data : data copy
   * @param {any} row : hàng active
   * @param {any} col : cột active
   * @param {any} rowCount : số hàng được chọn
   * @param {any} colCount : số cột được chọn
   * @param {any} sheet : sheet thực hiện copy
   * @param {any} isCut : biến check trong trường hợp cut
   * created by Tvtam 06.12.2023
   */
  copyToClipboard(data, row, col, rowCount, colCount, sheet, isCut) {
    var textToCopy = data.map(row => row.join('\t')).join('\n');
    navigator.clipboard
      .writeText(textToCopy)
      .then(function () {
        if (isCut) {
          navigator.clipboard.IsCutSpreadJS = `iscutSpreadJS,${row.toString()}, ${col.toString()}, ${rowCount.toString()}, ${colCount.toString()},${sheet.name()}`;
        }
        //console.log('Sao chép thành công vào bộ nhớ tạm');
      })
      .catch(function (err) {
        console.error('Sao chép thất bại vào bộ nhớ tạm', err);
      });
  }

  /**
   * Paste dữ liệu từ bộ nhớ tạm của trình duyệt vào spreadjs
   * @param {any} sheet : sheet paste
   * @param {any} row : indext hàng
   * @param {any} col : indext cột
   * created by Tvtam 06.12.2023
   */
  pasteFromClipboard(sheet, row, col) {
    let me = this;
    navigator.clipboard
      .readText()
      .then(function (text) {
        if (text) {
          var clipboardData = text
            .split('\n')
            .map(row => row.split('\t'))
            .map(row =>
              row.map(value => {
                // Try to parse the value to a number
                if (value == null || value === true || value === false || value.trim() === '') return value;
                const parsedValue = Number(value);

                // Check if the parsing was successful and return the appropriate value
                return isNaN(parsedValue) ? value : parsedValue;
              }),
            );
          if (navigator.clipboard.IsCutSpreadJS && navigator.clipboard.IsCutSpreadJS != null) {
            // mảng chứa thông tin để xóa cell sau khi cắt tại worksheet
            var arrayCut = navigator.clipboard.IsCutSpreadJS.split(',').map(function (item) {
              return isNaN(item) ? item : Number(item);
            });
            // Kiểm tra đang ở mode cắt và ở sheet cắt
            if (arrayCut[0] && arrayCut[0] == 'iscutSpreadJS' && sheet.name() == arrayCut[5]) {
              me.clearCutData(
                sheet,
                arrayCut[1],
                arrayCut[2],
                arrayCut[1] + arrayCut[3],
                arrayCut[2] + arrayCut[4],
                text,
              );
              // bỏ trạng thái cắt
              navigator.clipboard.IsCutSpreadJS = null;
            }
          }
          // Thực hiện dán
          sheet.setArray(row, col, clipboardData);
        }
      })
      .catch(function (err) {
        console.error('Unable to paste data from clipboard', err);
      });
  }
  /**
   * Xóa các cell trong trường hợp cắt nội bộ sheet
   * @param {any} sheet
   * @param {any} rowStart
   * @param {any} colStart
   * @param {any} rowEnd
   * @param {any} colEnd
   * created by Tvtam 06.12.2023
   */
  clearCutData(sheet, rowStart, colStart, rowEnd, colEnd, arrayText) {
    var textToCopy = sheet
      .getArray(rowStart, colStart, rowEnd - rowStart, colEnd - colStart)
      .map(row => row.join('\t'))
      .join('\n');
    // Điều kiện đang kiểm tra đang cắt trong nội bộ
    if (textToCopy.replace(/\s/g, '') == arrayText.replace(/\s/g, '')) {
      for (let i = rowStart; i < rowEnd; i++) {
        for (let j = colStart; j < colEnd; j++) {
          sheet.setValue(i, j, '');
        }
      }
    }
  }
  /**
   * Ghi đề lại sự kiện từ bàn phím
   * @param {any} wb : workbook
   * created by Tvtam 06.12.2023
   */
  customEventkeyBoardEvents(wb) {
    const actionCopy = 'copy',
      actionPaste = 'paste',
      actionCut = 'cut';
    if (!wb.element.data('eventOn')) {
      wb.element
        .on(actionPaste, function (event) {
          // Ngăn chặn hành động paste mặc định
          event.stopPropagation();
          event.preventDefault();
          this.contextMenuCommandCustom(wb, actionPaste);
        })
        .data('eventOn', true);
    }
    wb.element.keydown(function (event) {
      if (event.ctrlKey && event.keyCode === 67) {
        event.preventDefault();
        this.contextMenuCommandCustom(wb, actionCopy);
      }

      if (event.ctrlKey && event.keyCode === 86) {
        event.preventDefault();
        this.contextMenuCommandCustom(wb, actionPaste);
      }

      if (event.ctrlKey && event.keyCode === 88) {
        event.preventDefault();
        this.contextMenuCommandCustom(wb, actionCut);
      }
    });
  }
  /**
   * Valide biểu thức từ string chuyển sang để tính toán
   * @param {string} expression : biểu thức
   * @param {array} arrayParam  : mảng tên các biến trong biểu thức
   * created tvtam 01/03/2024
   */
  validateExpression(expression, arrayParam) {
    const replaceValues = (str, values) => {
      return str.replace(/\[(.*?)\]/g, (_, match) => {
        return values[match] || '0';
      });
    };
    let values = {};
    arrayParam.forEach((item, index) => {
      values[item] = '1';
    });
    const result = replaceValues(expression, values);
    
    try {
      // Đánh giá biểu thức để kiểm tra mọi trường hợp chia cho 0
      const operation = new Function('return ' + result);
      const evalResult = operation();
      
      // Kiểm tra xem có phải vô cực hay NaN (do chia cho 0)
      if (!isFinite(evalResult)) {
        return false;  // Công thức không hợp lệ vì chia cho 0
      }
      
      return true;
    } catch (error) {
      return false;
    }
  }
  /**
   * Lấy số dự từ 1 biểu thuyết minh theo điều kiện
   * @param {Array} dataSources Dữ liệu người dùng nhập liệu
   * @param {Array} arrayFilter Điều kiện lọc dữ liệu
   * @param {string} fieldCode Mã trường sử dụng để tính dự toán
   * @returns số dự toán  theo 1 biểu thuyết minh (int)
   * created tvtam 01/03/2024
   */
  getEstimatedResultsByPresent(dataSources, arrayFilter, fieldCode) {
    let filteredArr = [];
    if (!arrayFilter || arrayFilter.length <= 0) {
      filteredArr = dataSources;
    } else {
      arrayFilter.forEach(element => {
        switch (element.type_condition) {
          case i18nEnum.typeConditionFilterEstimates.Equals: // bằng
            filteredArr = dataSources.filter(item => element.value_condition.includes(item[element.field_code]));
            break;
          default: // bằng
            filteredArr = dataSources.filter(item => element.value_condition.includes(item[element.field_code]));
            break;
        }
      });
    }

    // ví dụ mã trường dữ liệu tính tổng
    //fieldCode = "DTNKH";
    const total = filteredArr.reduce((acc, obj) => acc + (obj[fieldCode] ? obj[fieldCode] : 0), 0);
    return total;
  }

  /**
   * chuấn hóa điều điều kiện lọc
   * @param {array} listCodition danh sách điều kiện thô
   * @param {array} valueTypeList danh sách các giá trị của trường dữ liệu danh sách
   */
  genCoditionFilterEstimate(listCodition, valueTypeList) {
    let arrayFilter = [];
    if (!listCodition && listCodition.length < 1) return arrayFilter;
    listCodition.forEach(element => {
      let dataCodition = JSON.parse(element.value).map(
        key => valueTypeList.find(item => item.explanation_form_model_list_type_id == key)?.value,
      );
      arrayFilter.push({
        field_code: element.field_code,
        value_condition: dataCodition,
        type_condition: element.condition_type,
      });
    });
    return arrayFilter;
  }
  /**
   * Render workbook bằng file
   * @param {*} wb
   * @param {*} file
   */
  openByFile(wb, file) {
    let openOptions = {
      openMode: 0,
      includeStyles: true,
      includeFormulas: true,
      frozenColumnsAsRowHeaders: true,
      frozenRowsAsColumnHeaders: true,
      fullRecalc: true,
      dynamicReferences: true,
      calcOnDemand: true,
      includeUnusedStyles: true,
      incrementalLoading: true,
      encoding: 'UTF-8',
      rowDelimiter: '\r\n',
      columnDelimiter: ',',
    };
    wb.open(
      file,
      function () { },
      function () { },
      openOptions,
    );
    this.changeStatusLockWorkbook(true, wb);
  }
  /**
   * gen ra thông tin cột của gird view mẫu hiển thị người dùng
   * @param {array} listItemModel danh sách trường dữ liệu của biểu thuyết minh
   * @returns
   */
  genLayoutGirdView(listItemModel, mode = 0) {
    let layout = [];
    let data = {};
    listItemModel.forEach(item => {
      if (item.is_hide_show) {
        if (mode != 0 && item.is_owner_summary) {
          layout.push({
            sortable: false,
            width: 150,
            caption: item.field_name,
            dataField: item.field_code,
          });
        } else if (mode == 0) {
          layout.push({
            sortable: false,
            width: 150,
            caption: item.field_name,
            dataField: item.field_code,
          });
        }
      }
    });
    if (layout.length > 0) {
      layout.forEach(obj => {
        data[obj.dataField] = '';
      });
    }
    return { layoutTemplate: layout, datas: [data] };
  }

  /**
   * Set đóng mở workbook
   * @param {boolean} status trạng thái workbook true - khóa || false - mở
   * @param {*} wb
   */
  changeStatusLockWorkbook(status, wb, addRow = null) {
    wb.suspendPaint();
    wb.suspendEvent();

    // let isEditStart = false;
    let numberSheet = wb.getSheetCount();
    // if (!status) {
    //   isEditStart = true;
    // }
    while (numberSheet) {
      let sheet = wb.getSheet(numberSheet - 1);
      let headerCols = null;
      if (sheet.tag()?.headerInfo) {
        try {
          headerCols = JSON.parse(sheet.tag()?.headerInfo);
        } catch {
          headerCols = null;
        }
      }

      if (!addRow) {
        sheet.options.isProtected = status;
        sheet
          .getRange(0, 0, sheet.getRowCount(), sheet.getColumnCount(), GC.Spread.Sheets.SheetArea.viewport)
          .locked(status);
        sheet.options.protectionOptions.allowDeleteRows = !status;
        sheet.options.protectionOptions.allowDeleteColumns = !status;
        sheet.options.protectionOptions.allowInsertRows = !status;
        sheet.options.protectionOptions.allowInsertColumns = !status;
        sheet.options.protectionOptions.allowDargInsertRows = !status;
        sheet.options.protectionOptions.allowDragInsertColumns = !status;
        sheet.options.protectionOptions.allowResizeColumns = true;
        sheet.options.protectionOptions.allowResizeRows = true;
      }
      if (!status && headerCols) {
        let checkNotEdit = headerCols.some(item => item.isNotEdit);
        if (checkNotEdit) {
          sheet.options.isProtected = true;
          //isEditStart = true;
          headerCols.forEach((item, index) => {
            if (item.isNotEdit) {
              sheet.getRange(0, index, sheet.getRowCount(), 1).locked(true);
            } else {
              sheet.getRange(0, index, sheet.getRowCount(), 1).locked(false);
            }
          });
        }
      }

      //Thay đổi màu viền vùng chọn
      if (status) {
        sheet.options.selectionBorderColor = i18nEnum.WorkbookEnum.LockedBorderColor;
      } else {
        sheet.options.selectionBorderColor = null;
      }
      numberSheet--;
    }

    //Thay đổi màu nền bảng tính
    if (status) wb.options.backColor = i18nEnum.WorkbookEnum.LockedBackColor;
    else wb.options.backColor = i18nEnum.WorkbookEnum.DefaultBackColor;

    wb.resumeEvent();
    wb.resumePaint();
  }

  /**
   * tạo workbook từ nhiều dataSource vào nhiều sheets
   * @param {*} dataTemplates
   * @param {*} wb
   */
  async renderWorkbookFormultipleTemplate(wb, dataTemplates, wbComponent, customNames) {
    let me = this;
    if (!dataTemplates || dataTemplates == null) return;
    // xóa sheet thừa
    while (wb.getSheetCount() > dataTemplates.length) {
      wb.removeSheet(0);
    }
    // add thêm sheet cần
    if (wb.getSheetCount() < dataTemplates.length) {
      for (let index = wb.getSheetCount(); index < dataTemplates.length; index++) {
        if (typeof wbComponent?.addSheetWb == 'function') {
          wbComponent.addSheetWb(index);
        }
      }
    }

    //Chuẩn hóa lại customNames
    customNames = this.standardizeCustomNames(customNames);

    wb.suspendEvent();
    wb.suspendPaint();
    wb.suspendCalcService();
    // Chỉ copy value
    wb.options.allowCopyPasteExcelStyle = false;
    wb.options.tabEditable = false;
    wb.options.allowExtendPasteRange = true;
    dataTemplates.forEach(async (element, index) => {
      let sheet = wb.getSheet(index);
      if (sheet) {
        sheet.reset();
        var template = this.rebuildTemplate(element.template, customNames);

        sheet.fromJSON(template, {
          doNotRecalculateAfterLoad: true,
        });

        if (index == 0) {
          sheet.isSelected(true);
        } else {
          sheet.isSelected(false);
        }
        if (element.data && JSON.parse(element.data) && JSON.parse(element.data).length > 0) {
          me.addStyleReRender(sheet, JSON.parse(element.data).length);
          element.data = me.convertDataViewWorkbook(JSON.parse(element.data), JSON.parse(element.header_info));
          sheet.setDataSource(JSON.parse(element.data));
          //Gán trạng thái cho các dòng dữ liệu đã nhập
          let dataSource = sheet.getDataSource();
          if (dataSource?.length) {
            dataSource.map(t => (t.state = i18nEnum.WorkbookEnum.RowStateEdited));
          }
        } else {
          element.data_source_default = element.data_source_default ? element.data_source_default : '[{}]';
          element.data_source_default = me.convertDataViewWorkbook(
            JSON.parse(element.data_source_default),
            JSON.parse(element.header_info),
          );
          sheet.setDataSource(JSON.parse(element.data_source_default));
        }

        if (element.header_info && JSON.parse(element.header_info) && JSON.parse(element.header_info).length > 0) {
          sheet.bindColumns(me.standardizedHeaderInfo(JSON.parse(element.header_info), sheet));
          let isCheckCommnet = JSON.parse(element.header_info).some(obj => obj.hasOwnProperty('commentCol'));
          if (!isCheckCommnet) {
            let listModer = await explanationFormModelAPI.GetByExplanationForm({
              explanFormId: element.explanation_form_id,
            });
            if (listModer && listModer.length > 0) {
              element.header_info = JSON.stringify(
                me.addCommentToHeaderInfo(JSON.parse(element.header_info), listModer),
              );
            }
          }
          JSON.parse(element.header_info).forEach((element, index) => {
            let maxSize = 500;
            if (element.size > 500) {
              sheet.getCell(-1, index, GC.Spread.Sheets.SheetArea.colHeader).wordWrap(true);
              sheet.setColumnWidth(index, 500);
              if (element.size > maxSize) {
                sheet.setRowHeight(0, (element.size / 500) * 48, GC.Spread.Sheets.SheetArea.colHeader);
                maxSize = element.size;
              }
            }
            // set comment nếu có
            if (element.commentCol) {
              me.addCommentWorkbook(element.commentCol, sheet, index);
            }
          });
          me.setFormatterDefault(sheet, JSON.parse(element.header_info));
          if (me.checkUseHeaderInfo(JSON.parse(element.header_info))) {
            let newTag = {
              ...sheet.tag(),
              headerInfo: element.header_info,
            }
            sheet.tag(newTag);
          }
        }
        me.clearDataDefault(sheet, JSON.parse(element.header_info));
        //Thêm dòng mặc định
        if (!element.data || !JSON.parse(element.data) || JSON.parse(element.data).length === 0) {
          me.addDefaultDataRow(sheet);
        }
        if (element.explanation_form_code) {
          if (element.explanation_form_code != sheet.name()) {
            sheet.name(element.explanation_form_code);
          }
        } else {
          sheet.name('sheet' + index.toString());
        }
      }
    });
    wb.resumeCalcService();
    wb.resumePaint();
    wb.resumeEvent();
    me.resetSelectCellWorkbook(wb);
  }

  /**
   * Bind customNames
   * @param {*} template 
   * @param {*} customNames 
   * @returns 
   */
  rebuildTemplate(template, customNames) {

    let templateObj = null;
    try {
      if (!template) {
        templateObj = {};
      };
      templateObj = JSON.parse(template);
    }
    catch {
      templateObj = {};
    }

    var hasDicNames = templateObj.names?.find(t => t.name == i18nEnum.WorkbookEnum.HasDicNames);
    if (!hasDicNames && customNames && customNames.length > 0) {
      templateObj.names = customNames;
    }

    return templateObj;
  }

  /**
   * Chuẩn hóa lại customnames
   * @param {*} customNames 
   * @returns 
   */
  standardizeCustomNames(customNames) {
    if (!customNames || customNames.length == 0) return [];

    let result = [];

    customNames.forEach(name => {
      if (!name) {
        return;
      }

      let key = name.FieldCode,
        value = name.Value;

      if (i18nEnum.WorkbookDefaultNames.find(t => t.FieldCode == key)) return;

      if (Number(value)) {
        value = `=${value}`;
      } else {
        value = `="${value}"`;
      }

      result.push({
        name: key,
        formula: value,
        row: null,
        col: null,
        isReadOnly: false
      });
    });

    return result;
  }

  /**
   * Lấy dữ liệu columns của workbook
   * TMNghia 31/03/2024
   * @param {*} jsonDatas
   */
  getWorkbookColumns(jsonDatas) {
    let columns = {};
    //Duyệt qua từng biểu mẫu để lấy giá trị headerInfo
    jsonDatas.forEach(data => {
      if (!data.header_info) {
        return;
      }

      let dataHeader = JSON.parse(data.header_info);
      columns[data.explanation_form_code] = [];
      if (dataHeader?.length > 0) {
        columns[data.explanation_form_code] = dataHeader;
      }
    });

    return columns;
  }

  /**
   * Validate form nhập liệu
   * TMNghia 28/03/2024
   */
  validateWorkbook(workBook, sheetColumns) {
    workBook.suspendPaint();
    workBook.suspendEvent();
    let sheets = workBook.sheets;
    let invalidSheet = '';

    sheets.forEach((sheet, index) => {
      let sheetName = sheet.name(),
        columns = sheetColumns[sheetName]?.filter(t => t.visible !== false) || [], //Lấy ra các cột cần validate
        validSheet = this.validateSheet(sheet, columns);

      //Nếu có sheet lỗi thì trả về sheet lỗi để hiển thị
      if (!validSheet && !invalidSheet) {
        invalidSheet = sheetName;
      }
    });

    workBook.resumeEvent();
    workBook.resumePaint();

    //Hiển thị sheet lỗi
    if (invalidSheet) {
      workBook.setActiveSheet(invalidSheet);
      return false;
    }

    return true;
  }

  /**
   * Hàm validate sheet
   * TMNghia 28/03/2024
   */
  validateSheet(sheet, columns) {
    let valid = true;
    //Danh sách ô lỗi
    let dataSource = sheet.getDataSource();
    let dataSave = dataSource.filter(item => item.state);
    if (!dataSource?.length || !dataSave || dataSave.length === 0) {
      return valid;
    }
    //Remove validate style
    sheet.comments.clear();
    for (let i = 0; i < dataSave.length; i++) {
      for (let j = 0; j < columns.length; j++) {
        let column = columns[j];
        //Validate từng dòng
        let cell = sheet.getCell(i, column.sort_order, GC.Spread.Sheets.SheetArea.viewport);
        let res = this.validateCell(cell, column).status;
        valid = !res ? res : valid;
      }
    }

    return valid;
  }
  /**
   * Hàm validate từng ô
   * TMNghia 28/03/2024
   */
  validateCell(cell, column) {
    let data_type = column.data_type,
      colName = column.displayName,
      value = cell.value();

    //Nếu như là trường bắt buộc nhập và có hiển thị
    let message = '';

    //Validate không được để trống
    if (!(value?.toString().length > 0)) {
      if (column.is_required) {
        message = `${colName} ${i18nEnum.InvalidCellMessage.Required}`;
      }
    }
    //Nếu đã nhập liệu rồi thì validate định dạng
    else {
      switch (data_type) {
        //Dữ liệu dạng ngày tháng
        case i18nEnum.ModelDataType.Date:
          var dateObject = moment(value, 'DD/MM/YYYY', true);
          // Kiểm tra xem đối tượng Moment có hợp lệ không
          if (!dateObject.isValid()) {
            message = `${colName} ${i18nEnum.InvalidCellMessage.Format}`;
          }
          break;
        //Dữ liệu dạng số
        case i18nEnum.ModelDataType.Number:
        case i18nEnum.ModelDataType.Ratio:
        case i18nEnum.ModelDataType.Currency:
        case i18nEnum.ModelDataType.Constant:
          let regex = /^-?\d+(\.\d+)?$/;
          if (!regex.test(value)) {
            message = `${colName} ${i18nEnum.InvalidCellMessage.Format}`;
          }
          break;
      }
    }
    //Nếu tồn tại lỗi thì bôi đỏ cell
    if (message) {
      this.styleInvalidCell(cell, message);
      return { status: false, mode: 0 };
    }
    // set comment nếu có
    cell.comment(null);
    if (column.commentCol) {
      this.addCommentCellWorkbook(column.commentCol, cell);
      return { status: true, mode: 1 };
    }
    return { status: true, mode: 0 };
  }

  /**
   * Bôi đỏ ô
   * TMNghia 28/03/2024
   */
  styleInvalidCell(cell, message) {
    cell.setBorder(new GC.Spread.Sheets.LineBorder('Red', GC.Spread.Sheets.LineStyle.thin), { all: true });
    //Comment message
    var comment = cell.sheet.comments.add(cell.row, cell.col, message);
    comment.text(message);
    comment.displayMode(GC.Spread.Sheets.Comments.DisplayMode.hoverShown);
    comment.autoSize(true);
  }

  /**
   * Hàm genFull thông tin của biểu thuyết minh
   * @param {array} dataModels danh sách trường dữ liệu của biểu thuyết minh
   */
  async updateInfoExplanationForm(file, path, nameFile, headerInfor, dataSource) {
    dictionaryPresentAPI.setupExplanationForm(
      file,
      path,
      nameFile,
      JSON.stringify(headerInfor),
      JSON.stringify(dataSource),
    );
  }

  /**
   * Thực thi hành động toolbar
   * @param {workbook} wb
   * @param {object} action đối tượng hành động
   * @param {object} value value hành động
   * tvtam
   */
  applyActionToolbar(wb, action) {
    switch (action.toolbar.nameCommmand) {
      case i18nEnum.actionToolbar.Undo:
        wb.undoManager().undo();
        return;
      case i18nEnum.actionToolbar.Redo:
        wb.undoManager().redo();
        return;
    }
    wb.commandManager().execute({ cmd: 'actionToolbar', action: action });
  }
  /**
   * Hàm thực thi action từ toolbar
   * @param {*} wb
   * @param {*} options
   * @returns
   */
  excuteActionToolbar(wb, options) {
    let me = this;
    let activeSheet = wb.getActiveSheet();
    let rangeSelects = activeSheet.getSelections();
    if (!rangeSelects || rangeSelects == null || rangeSelects.length <= 0) return;
    wb.suspendPaint();
    wb.suspendEvent();
    rangeSelects.forEach(function (element) {
      if (element.row == -1) {
        element.row = 0;
      }
      if (element.col == -1) {
        element.col = 0;
      }
      let activeRange = activeSheet.getRange(
        element.row,
        element.col,
        element.rowCount,
        element.colCount,
        GC.Spread.Sheets.SheetArea.viewport,
      );

      switch (options.action.toolbar.nameCommmand) {
        case i18nEnum.actionToolbar.FontColor:
          activeRange.foreColor(options.action.value);
          break;
        case i18nEnum.actionToolbar.BackgroundColor:
          activeRange.backColor(options.action.value);
          break;
        case i18nEnum.actionToolbar.StyleText:
        case i18nEnum.actionToolbar.FontFamily:
          activeRange.fontFamily(options.action.value.newData.value);
          break;
        case i18nEnum.actionToolbar.FontSize:
          activeRange.fontSize(`${options.action.value.newData.value}pt`);
          break;
        case i18nEnum.actionToolbar.Bold:
          let fontWeight = activeRange.fontWeight() ?? i18nEnum.WorkbookEnum.DefaultFontWeight;
          fontWeight =
            fontWeight == options.action.toolbar.code
              ? i18nEnum.WorkbookEnum.DefaultFontWeight
              : options.action.toolbar.code;
          activeRange.fontWeight(fontWeight);
          break;
        case i18nEnum.actionToolbar.Italicized:
          let fontStyle = activeRange.fontStyle() ?? i18nEnum.WorkbookEnum.DefaultFontStyle;
          fontStyle =
            fontStyle == options.action.toolbar.code
              ? i18nEnum.WorkbookEnum.DefaultFontStyle
              : options.action.toolbar.code;
          activeRange.fontStyle(fontStyle);
          break;
        case i18nEnum.actionToolbar.Underlined:
          let decorationType = activeRange.textDecoration();
          decorationType =
            decorationType == GC.Spread.Sheets.TextDecorationType.none
              ? GC.Spread.Sheets.TextDecorationType.underline
              : GC.Spread.Sheets.TextDecorationType.none;
          activeRange.textDecoration(decorationType);
          break;
        case i18nEnum.actionToolbar.Freeze:
          activeSheet.frozenRowCount(activeSheet.getActiveRowIndex());
          activeSheet.frozenColumnCount(activeSheet.getActiveColumnIndex());
          return;
        case i18nEnum.actionToolbar.UnFreeze:
          activeSheet.frozenRowCount('');
          activeSheet.frozenColumnCount('');
          return;
        case i18nEnum.actionToolbar.WordWrap:
          let value = activeRange.wordWrap();
          activeRange.wordWrap(!value);
          break;

        case i18nEnum.actionToolbar.Indent:
          // lấy ra fontStyle hiện có
          let indent = activeRange.textIndent();
          if (!indent) {
            indent = 0;
          }
          activeRange.textIndent(++indent);
          break;
        case i18nEnum.actionToolbar.UnIndent:
          // lấy ra fontStyle hiện có
          let indents = activeRange.textIndent();
          activeRange.textIndent(--indents);
          break;
        case i18nEnum.actionToolbar.MergeCell:
          let statusMerger = activeSheet.getSpan(element.row, element.col);
          if (statusMerger) {
            activeSheet.removeSpan(element.row, element.col);
          } else {
            activeSheet.addSpan(element.row, element.col, element.rowCount, element.colCount);
          }
          break;
        case i18nEnum.actionToolbar.LeftAlign:
          activeRange.hAlign(GC.Spread.Sheets.HorizontalAlign.left);
          break;
        case i18nEnum.actionToolbar.CenterAlign:
          activeRange.hAlign(GC.Spread.Sheets.HorizontalAlign.center);
          break;
        case i18nEnum.actionToolbar.RightAlign:
          activeRange.hAlign(GC.Spread.Sheets.HorizontalAlign.right);
          break;
        case i18nEnum.actionToolbar.DistributedAlign:
          activeRange.hAlign(GC.Spread.Sheets.HorizontalAlign.distributed);
          break;
        case i18nEnum.actionToolbar.TopAlign:
          activeRange.vAlign(GC.Spread.Sheets.VerticalAlign.top);
          break;
        case i18nEnum.actionToolbar.MidAlign:
          activeRange.vAlign(GC.Spread.Sheets.VerticalAlign.center);
          break;
        case i18nEnum.actionToolbar.BottomAlign:
          activeRange.vAlign(GC.Spread.Sheets.VerticalAlign.bottom);
          break;
        case i18nEnum.actionToolbar.Formatter:
          if (options.action.value.newData.display == 'Number') {
            // thực hiện chuyển đổi về kiểu số
            //todo trả về số chữ só phần thập vân lớn nhất custom nếu có nhu cầu đổi formatter thì sửa thêm
            let numberDecimal = me.setFormatCellTypeNumber(activeSheet, element);
          }
          activeRange.formatter(options.action.value.newData.value);
          break;
        case i18nEnum.actionToolbar.BorderAll:
          activeRange.setBorder(new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin), {
            all: true,
          });
          break;
        case i18nEnum.actionToolbar.IncreaseDecimal:
          me.setRangeFormatter(activeSheet, activeRange, true);
          break;
        case i18nEnum.actionToolbar.DecreaseDecimal:
          me.setRangeFormatter(activeSheet, activeRange, false);
          break;
        case i18nEnum.actionToolbar.BorderOptions:
          let command = options.action.value;
          //Nếu là none thì border mặc định
          if (command.option == i18nEnum.BorderOptions.None) {
            activeRange.setBorder(null, { all: true });
          } else {
            //Các option border khác
            let borderOption = {},
              borderStyle = new GC.Spread.Sheets.LineBorder(
                i18nEnum.WorkbookEnum.BorderColor,
                GC.Spread.Sheets.LineStyle.thin,
              );
            borderOption[command.option] = true;

            activeRange.setBorder(borderStyle, borderOption);
          }
          break;

        case i18nEnum.actionToolbar.Formatter:
          activeRange.formatter(options.action.value.newData.value);
          break;
        default:
          break;
      }
    });
    wb.resumeEvent();
    wb.resumePaint();
  }

  /**
   * Thiết lập tăng giảm số thập phân cho toàn bộ range
   * @param {*} sheet 
   * @param {*} range 
   * @param {*} increased 
   * @returns 
   */
  setRangeFormatter(sheet, range, increased = true) {
    if (!sheet || !range) return;

    for (let r = range.row; r < range.row + range.rowCount; r++) {
      for (let c = range.col; c < range.col + range.colCount; c++) {
        let cell = sheet.getCell(r, c);
        let formatter = cell.formatter();
        if (increased) {
          cell.formatter(this.increaseDecimalExcel(formatter));
        } else {
          cell.formatter(this.decreaseDecimalExcel(formatter));
        }
      }
    }
  }

  /**
   * tăng chứ số thập phân
   * @param {string} formatter định dạng hiện tại
   * @returns
   */
  increaseDecimalExcel(formatter) {
    if (!formatter || formatter.indexOf('0') === -1) {
      return formatter;
    }
    if (formatter.indexOf('.') === -1) {
      let postionlast = formatter.lastIndexOf('0');
      if (postionlast !== -1) {
        return formatter.slice(0, postionlast + 1) + '.0' + formatter.slice(postionlast + 1);
      }
      return formatter + '.0';
    }
    let index = 1;
    while (1) {
      if (formatter.indexOf('.' + '0'.repeat(index)) === -1) {
        //console.log(this.replaceAll(formatter, '.' + '0'.repeat(index - 1), '.' + '0'.repeat(index)));
        return this.replaceAll(formatter, '.' + '0'.repeat(index - 1), '.' + '0'.repeat(index));
      }
      index++;
    }
  }

  /**
   * Giảm chứ số thập phân
   * @param {string} formatter định dạng hiện tại
   * @returns
   */
  decreaseDecimalExcel(formatter) {
    if (!formatter || formatter.indexOf('.') === -1) {
      return formatter;
    }
    let index = 1;
    while (1) {
      if (formatter.indexOf('.' + '0'.repeat(index)) === -1) {
        if ('.' + '0'.repeat(index - 1) == '.0') {
          return this.replaceAll(formatter, '.' + '0'.repeat(index - 1), '0'.repeat(index - 2));
        }
        return this.replaceAll(formatter, '.' + '0'.repeat(index - 1), '.' + '0'.repeat(index - 2));
      }
      index++;
    }
  }

  /**
   * Hàm sinh 10 dòng mặc định cho mẫu
   * TMNghia 01/04/2024
   */
  addDefaultDataRow(sheet) {
    let currentRowNumber = sheet.getDataSource()?.length;
    if (currentRowNumber >= i18nEnum.WorkbookEnum.DefaultRowNumber) {
      return;
    }

    let columnCount = sheet.getColumnCount();

    if (columnCount == 0) {
      return;
    }

    let addRowNumber = i18nEnum.WorkbookEnum.DefaultRowNumber - currentRowNumber;
    sheet.addRows(currentRowNumber, addRowNumber); // Thêm dòng mới
    //Copy công thức và style từ dòng 0 sang các dòng thêm mới
    for (let i = currentRowNumber; i < i18nEnum.WorkbookEnum.DefaultRowNumber; i++) {
      let rowIndex = i;
      sheet.copyTo(0, 0, rowIndex, 0, 1, columnCount, GC.Spread.Sheets.CopyToOptions.formula);
      sheet.copyTo(0, 0, rowIndex, 0, 1, columnCount, GC.Spread.Sheets.CopyToOptions.style);
    }
    this.styleRowDefault(sheet);
  }
  /**
   * Hàm chuyển name cell thành dòng cột
   */
  excelCellToNum(cell) {
    if (!cell) {
      return { row: 0, column: 0 };
    }
    const colStr = cell.match(/[A-Za-z]+/)[0];
    const rowStr = cell.match(/[0-9]+/)[0];

    let colNum = 0;
    for (let i = 0; i < colStr.length; i++) {
      colNum = colNum * 26 + colStr.charCodeAt(i) - 64;
    }

    return { row: parseInt(rowStr, 10) - 1, col: colNum - 1 };
  }
  /**
   * Hàm set giá trị default cho mẫu chung
   * TMNghia 03/04/2024
   * @param {*} wb
   */
  setDefaultStyle(wb) {
    let sheets = wb.sheets;
    sheets.forEach(sheet => {
      //Row height
      sheet.defaults.rowHeight = i18nEnum.WorkbookEnum.DefaultRowHeight;
      let sheetRange = sheet.getRange(0, 0, sheet.getRowCount(), sheet.getColumnCount());

      let rangeFont = `${i18nEnum.WorkbookEnum.DefaultFontWeight} ${i18nEnum.WorkbookEnum.DefaultFontStyle} ${i18nEnum.WorkbookEnum.DefaultFontSize}pt ${i18nEnum.WorkbookEnum.DefaultFontFamily}`;
      sheetRange.font(rangeFont);

      // Border cho mẫu
      sheetRange.setBorder(
        new GC.Spread.Sheets.LineBorder(i18nEnum.WorkbookEnum.BorderColor, GC.Spread.Sheets.LineStyle.thin),
        { all: true },
      );
    });
  }
  /**
   * Hàm lấy chiều rộng của column
   * TMNghia 03/04/2024
   */
  getFitWidthColumn(text, mode) {
    // Tạo một canvas để sử dụng context 2d
    let tmpElement = document.createElement('canvas'),
      context = tmpElement.getContext('2d'),
      defaultFontSize = i18nEnum.WorkbookEnum.DefaultFontSize;

    context.font = defaultFontSize + 'pt Arial';

    // Đo chiều rộng của chuỗi văn bản
    var width = context.measureText(text).width;

    //Trả về chiều rộng của cột hoặc chiều rộng mặc định
    if (mode) return width;
    return width > i18nEnum.WorkbookEnum.DefaultColumnWidth ? width : i18nEnum.WorkbookEnum.DefaultColumnWidth;
  }
  /**
   * Hàm update thông tin mẫu thuyết minh
   * @param {array} dataModels danh sách trường dữ liệu
   */
  async updateConfigExplanationForm(dataModels, exForm) {
    let me = this;
    let wb = new GC.Spread.Sheets.Workbook();
    // Gen dataSoruce
    let dataSoruceDefault = null;
    let dataSourceSave = null;

    // header mang đi lưu
    let headerInfo = null;
    if (!dataModels || dataModels.length <= 0) {
      me.renderWorkbookByJson(wb, {});
    } else {
      let sheet = wb.getActiveSheet();
      // Gen dataSoruce
      dataSoruceDefault = await me.genDataDefault(dataModels);
      dataSourceSave = JSON.stringify(dataSoruceDefault);
      // gen header để gán lên mẫu
      headerInfo = await me.genInforColumns(dataModels);

      // gắn công thức lên mẫu
      await me.attachFormulaDefault(wb, dataModels);
      // gắn dataSource lên mẫu
      await me.renderWorkbookByDataSource(wb, dataSoruceDefault);
      // gắn thông tin côt lên mẫu
      await me.bindingheaderColumns(wb, headerInfo);
      // Gán style
      // Gán style
      me.setDefaultStyle(wb);
      sheet.name(exForm.explanation_form_code);
    }
    dictionaryPresentAPI.setupExplanationForm(
      JSON.stringify(wb.getActiveSheet().toJSON()),
      exForm.path,
      exForm.explanation_form_id,
      JSON.stringify(headerInfo),
      dataSourceSave,
    );
  }

  /**
   * Chuẩn hóa thứ tự key data mang đi lưu
   * @param {object} dataSoruce data cần chuẩn hóa
   * @param {object} dataSoruceDefault data mẫu
   */
  standardizeDataSave(dataSoruce, dataSoruceDefault) {
    const keys = Object.keys(dataSoruceDefault[0]);
    return dataSoruce.map(obj => {
      let newObj = {};
      keys.forEach(key => {
        newObj[key] = obj[key] || obj[key];
      });
      return newObj;
    });
  }

  /**
   * Map data với header
   * @param {array} data dữ liệu thuyets minh
   * @param {array} headerInfo dữ liệu header
   * @returns
   * tvtam
   */
  convertDataViewWorkbook(data, headerInfo) {
    let newObj = {};
    headerInfo.forEach(element => {
      newObj[element.name] = data[0][element.name];
    });
    data[0] = Object.assign({}, newObj, data[0]);
    return JSON.stringify(data);
  }
  /**
   * Hàm tách sheet lưu cho nhiều biểu thuyết minh
   * @param {*} wb
   * @param {*} estFormDatas
   */

  uploadMultipleTemplate(wb, estFormDatas, upLoadFile, options = { keyFileName: 'estimate_explanation_form_id' }) {
    let arrayestForm = [];
    estFormDatas.forEach(item => {
      arrayestForm.push({
        file: JSON.stringify(wb.getSheetFromName(item.explanation_form_code).toJSON()),
        fileName: item[options.keyFileName],
        url: item.path ? item.path : null,
        prefixPath: item.prefixPath ? item.prefixPath : null,
      });
    });
    if (upLoadFile && typeof upLoadFile === 'function') {
      upLoadFile(arrayestForm);
    }
  }

  /**
   * Chuẩn hóa lại header (gán lại celltype)
   * @param {object} headerInfo header cũ
   * @returns
   */
  standardizedHeaderInfo(headerInfo, sheet) {
    let me = this;
    headerInfo.forEach((element, index) => {
      element.displayName = me.mapNumberToLetter(index) + ` - ${element.displayName}`;
      element.size = element.size + me.getFitWidthColumn(me.mapNumberToLetter(index) + ' - ', true) + 5;
      sheet.setText(0, index, element.displayName, GC.Spread.Sheets.SheetArea.colHeader);
      // Nếu ko có formater mặc định là Text
      if (!element.formatter) {
        element.formatter = '@';
      }
      switch (element.data_type) {
        case i18nEnum.ExplanModeDataTypeNumber.List: // kiểu danh sách
          const combo = new GC.Spread.Sheets.CellTypes.ComboBox();
          combo._editable = true;
          //combo.editorValueType = GC.Spread.Sheets.CellTypes.EditorValueType.text;
          if (element.cellType && element.cellType?.items) {
            combo.items(element.cellType.items);
          }
          element.cellType = combo;
          break;
        case i18nEnum.ExplanModeDataTypeNumber.Boolean: // kiểu danh sách
          const checkbox = new GC.Spread.Sheets.CellTypes.CheckBox();
          element.cellType = checkbox;
          break;
      }
    });
    return headerInfo;
  }
  /**
   * set lại active cell về ô A1
   * @param {workBook} wb
   */

  resetSelectCellWorkbook(wb) {
    let activeSheet = wb.getActiveSheet();
    activeSheet.setActiveCell(0, 0);
    activeSheet.setSelection(0, 0, 1, 1);
  }

  /**
   * add lại formatter cho biểu mẫu
   * @param {*} sheet
   * @param {*} header
   */
  setFormatterDefault(sheet, header) {
    let rowCount = sheet.getRowCount();
    header.forEach(function (element) {
      if (element.formatter) {
        sheet
          .getRange(0, element.sort_order, rowCount, 1, GC.Spread.Sheets.SheetArea.viewport)
          .formatter(element.formatter);
      }
    });
  }

  /**
   * Gán style mặc định cho mẫu
   */
  setWorkSheetDefaultStyle(sheet) {
    let sheetStyle = new GC.Spread.Sheets.Style();
    sheetStyle.font = 'normal normal 11pt Times New Roman';
    sheetStyle.vAlign = GC.Spread.Sheets.VerticalAlign.center;
    sheet.setDefaultStyle(sheetStyle, GC.Spread.Sheets.SheetArea.viewport);
  }

  /**
   * Xử lý set lại formatter
   * @param {*} wb
   */
  setFormatterafterSave(wb) {
    wb.suspendPaint();
    wb.suspendEvent();
    let activeSheet = wb.getActiveSheet(),
      rowCount = activeSheet.getRowCount() < 100 ? activeSheet.getRowCount() : 100,
      ColCount = activeSheet.getColumnCount() < 100 ? activeSheet.getColumnCount() : 100;
    for (let row = 0; row < rowCount; row++) {
      for (let col = 0; col < ColCount; col++) {
        activeSheet.setFormatter(row, col, activeSheet.getFormatter(row, col));
      }
    }
    wb.resumePaint();
    wb.resumeEvent();
  }
  /**
   * Gán state cho các dòng khi có thay đổi dữ liệu
   */
  updateDataSourceRowState(sheet, changedCells) {
    //Danh sách các dòng đã thay đổi
    let rowIndexes = [...new Set(changedCells.map(t => t.row))];
    let rowDefaults = [];
    let dataSource = sheet.getDataSource();
    rowIndexes.map(i => {
      if (dataSource[i].state != i18nEnum.WorkbookEnum.RowStateEdited) {
        dataSource[i].state = i18nEnum.WorkbookEnum.RowStateEdited;
        rowDefaults.push(i);
      }
    });
    this.styleRowDefault(sheet, rowDefaults);
  }
  /**
   * Đóng trạng thái edit của sheet
   * @param {workbook} wb
   */
  submitActiveSheetWorkbook(wb) {
    let sheet = wb.getActiveSheet();
    sheet.endEdit();
  }

  /**
   * Xóa các giá trị mặc định của dữ liệu mang đi dòng đầu tiên
   * @param {*} sheet
   */
  clearDataDefault(sheet, headerInfo) {
    let colCount = sheet.getColumnCount();
    let dataSource = sheet.getDataSource();
    for (let index = 0; index < colCount; index++) {
      if (sheet.getText(0, index) == 0 && !sheet.getFormula(0, index)) {
        dataSource[0][headerInfo[index].name] = null;
      }
    }
  }

  updateComboboxReferences(sheet, cells) {
    let tagSheet = sheet.tag();
    if (!tagSheet || !cells) {
      return;
    }
    let comboboxReferences = tagSheet.comboboxReferences;
    if (!comboboxReferences) {
      return;
    }
    cells.forEach(cell => {
      let fields = comboboxReferences.Fields,
        values = comboboxReferences.Values,
        currentField = fields.find(t => t.col == cell.col);
      if (!currentField || !fields || !values) {
        return;
      }

      let preFields = fields.filter(t => t.grade <= currentField.grade);

      let preValues = [];
      preFields.forEach(field => {
        let preCell = sheet.getCell(cell.row, field.col);
        if (!preCell) {
          return;
        }

        preValues.push({
          field_code: field.field_code,
          value: preCell?.value(),
        });
      });

      values.filter(t => !preValues.find(u => u.value !== t[u.field_code]));
    });
  }

  /**
   * Lọc combobox theo điều kiện
   * @param {*} conditionFilter
   * @param {Number} rowCount Số dòng phát sinh thay đổi
   * @param {WorkSheet} sheet
   * tvtam 26.06.2024
   * modified by TMNghia: 23/01/2025 - refactor lại luồng, chỉ lọc tại vùng đang hoạt động, thêm dữ liệu từ MLNS vào điều kiện lọc
   */
  filterComboboxByContion(sheet) {
    if (!sheet || !sheet.tag()) return;
    let sheetTag = sheet.tag(),
      columns = JSON.parse(sheetTag.headerInfo);
    if (!columns || columns.length === 0) return;

    //Chỉ cần thực hiện trên vùng đang active
    let activeRange = sheet.getSelections()[0],
      row = activeRange.row,
      col = activeRange.col;

    //Lấy ra cột hiện tại
    let currentCol = columns.find(t => t.sort_order === col);
    if (!currentCol || !currentCol.is_filter || !currentCol.default_filter || currentCol.default_filter.length === 0) return;

    let defaultFilters = currentCol.default_filter.sort((a, b) => Object.keys(b).length - Object.keys(a).length);

    // Nếu có nhiều điều kiện lọc thì qua từng cái
    for (let j = 0; j < defaultFilters.length; j++) {
      let currFilter = defaultFilters[j],
        isConditionFiler = false,
        valueFilter = [];
      if (!currFilter || currFilter.length == 0) return;

      for (let key in currFilter) {
        if (key === 'DefaultFilter') continue;

        isConditionFiler = true;
        valueFilter = currFilter?.DefaultFilter;

        //Lấy dữ liệu theo key hiện tại
        let valueCell = this.getCurrentValue(sheet, columns, row, key);

        // Nếu ko thoản mãn 1 trong các điều kiện thì trả ra false luôn
        if (
          !currFilter[key].filter(item => item == valueCell) ||
          currFilter[key].filter(item => item == valueCell).length < 1
        ) {
          isConditionFiler = false;
          break;
        }
      }

      // Nếu thỏa mãn 1 điều kiện thì trả ra luôn
      if (isConditionFiler) {
        let itemCobobox = currentCol.cellType?.items
          ? currentCol.cellType?.items.filter(itemCobo => valueFilter.includes(itemCobo.text))
          : [];
        sheet.getCellType(row, col)._items = itemCobobox;
        if (!valueFilter.includes(sheet.getText(row, col))) {
          sheet.setText(row, col, '');
        }
        break;
      }
      let itemCobobox = currentCol.cellType?.items;
      sheet.getCellType(row, col)._items = itemCobobox;
    }
  }

  /**
   * Lấy dữ liệu hiện tại theo key
   */
  getCurrentValue(sheet, columns, row, key) {
    if (!sheet || !columns || !key) return;

    //Kiểm tra trong tag trước: đối với các trường thông tin chung
    if (sheet.getCustomName(key)) {
      return sheet.getCustomName(key).getExpression()?.value;
    }

    //Nếu không thì trả về dữ liệu nhập
    let indexCol = columns.find(object => object.name === key)?.sort_order;
    return sheet.getText(row, indexCol);
  }

  /**
   * Kiểm tra thuyết minh có lọc theo các combobox không
   * @param {string} headerInfo Thổng tin của các cột
   */
  checkUseHeaderInfo(headerInfo) {
    if (headerInfo.find(object => object.is_filter || object.isNotEdit || object.default_value)) {
      return true;
    }
    return false;
  }

  /**
   * Đăng ký các sự kiện custom
   * @param {workbook} wb Workbook
   * @param {array} commands Các command cần đăng ký
   */
  registerCommandCustom(wb, commands) {
    let commandManager = wb.commandManager();
    commands.forEach(command => {
      let commandCustom = {
        canUndo: command.canUndo,
        execute: function (context, options, isUndo) {
          var Commands = GC.Spread.Sheets.Commands;
          options.cmd = command.nameCommand;
          if (isUndo) {
            Commands.undoTransaction(context, options);
            return true;
          } else {
            Commands.startTransaction(context, options);
            if (command.actionCommand && typeof command.actionCommand === 'function') {
              command.actionCommand(context, options);
            }
            Commands.endTransaction(context, options);
            return true;
          }
        },
      };
      commandManager.register(command.nameCommand, commandCustom);
    });
  }
  /**
   * Thêm contextMenu cho workbook
   * @param {workbook} wb Workbook
   * @param {array} commands Các command cần xóa
   */
  addCustomContextMenu(wb, contextMenus) {
    let MenuDatas = wb.contextMenu.menuData;
    contextMenus.forEach(menuItem => {
      MenuDatas.push(menuItem);
    });
    wb.contextMenu.menuData = MenuDatas;
  }
  /**
   * Xóa contextMenu cho workbook
   * @param {workbook} wb Workbook
   * @param {array} commands Các command cần xóa
   */
  removeCustomContextMenu(wb, contextMenus) {
    let MenuDatas = wb.contextMenu.menuData;
    contextMenus.forEach(menuItem => {
      MenuDatas = MenuDatas.filter(t => t.id !== menuItem.id);
    });
    wb.contextMenu.menuData = MenuDatas;
  }
  /**
   * Hàm set style cho các cột mặc định
   * @param {*} sheet worksheet
   * @param {*} recordata số bản ghi đã nhập
   * @returns
   */
  styleRowDefault(sheet, indexRows = null) {
    let colCount = sheet.getColumnCount(),
      rowCount = sheet.getRowCount();
    if (indexRows) {
      let dataSoruce = sheet.getDataSource();
      dataSoruce.forEach((element, index) => {
        if (
          sheet.getRange(index, 0, 1, colCount).foreColor() == i18nEnum.ColorTextExplanation.Suggest &&
          element.state == i18nEnum.WorkbookEnum.RowStateEdited
        ) {
          indexRows.push(index);
        }
      });
      indexRows = [...new Set(indexRows)];
      if (indexRows.length > 0) {
        indexRows.forEach(indexRow => {
          sheet.getRange(indexRow, 0, 1, colCount).foreColor(i18nEnum.ColorTextExplanation.Default);
        });
      }
    } else {
      sheet.getRange(0, 0, rowCount, colCount).foreColor(i18nEnum.ColorTextExplanation.Suggest);
    }
  }

  /**
   * Gán lại style cho các dòng đã nhập
   * @param {*} sheet workSheet
   * @param {*} numberRecord số bản ghi đã nhập
   */
  addStyleReRender(sheet, numberRecord) {
    let colCount = sheet.getColumnCount(),
      rowCount = sheet.getRowCount(),
      index = 0;
    for (let i = 0; i < rowCount; i++) {
      if (sheet.getRange(i, 0, 1, colCount).foreColor() !== i18nEnum.ColorTextExplanation.Suggest) {
        if (i !== index) {
          sheet.copyTo(i, 0, index, 0, 1, colCount, GC.Spread.Sheets.CopyToOptions.formula);
          sheet.copyTo(i, 0, index, 0, 1, colCount, GC.Spread.Sheets.CopyToOptions.style);
        }
        index++;
      }
      if (index > numberRecord) {
        break;
      }
    }
  }
  /**
   * copy từ
   * @param {*} range
   * @param {*} sheet
   */
  customHeaderadvanced(range, sheet) {
    sheet.addRows(0, range.rowCount - 1, GC.Spread.Sheets.SheetArea.colHeader);
    // let style = new GC.Spread.Sheets.Style();
    //     let border = new GC.Spread.Sheets.LineBorder('black', GC.Spread.Sheets.LineStyle.thin); // Đường viền màu đen, độ dày mỏng
    //     style.borderLeft = border;
    //     style.borderTop = border;
    //     style.borderRight = border;
    //     style.borderBottom = border;
    //     style.fontFamily = 'Times New Roman';
    //     style.fontSize = '12px';
    //     style.fontWeight = 'bold';
    // sheet.getRange(0,0, range.rowCount,range.colCount, GC.Spread.Sheets.SheetArea.colHeader).setStyle(style);;
    for (let row = range.row; row < range.row + range.rowCount; row++) {
      for (let col = range.col; col < range.col + range.colCount; col++) {
        if (sheet.getSpan(row, col)) {
          let span = sheet.getSpan(row, col);
          sheet.addSpan(
            span.row - range.row,
            span.col - range.col,
            span.rowCount,
            span.colCount,
            GC.Spread.Sheets.SheetArea.colHeader,
          );
        }
        if (sheet.getValue(row, col)) {
          sheet.setValue(
            row - range.row,
            col - range.col,
            sheet.getValue(row, col),
            GC.Spread.Sheets.SheetArea.colHeader,
          );
        }
        sheet
          .getCell(row - range.row, col - range.col, GC.Spread.Sheets.SheetArea.colHeader)
          .setStyle(sheet.getStyle(row, col));
      }
    }
  }
  /**
   * Bắt đầu edit workbook
   * @param {workBook} wb
   */
  startEditWorkbook(wb) {
    let sheet = wb.getActiveSheet();
    sheet.startEdit();
    sheet.endEdit();
  }

  /**
   * Thực hiện set định dạng cho cell kiểu số
   * @param {WorkSheet} sheet
   * @param {object} range vùng chọn
   */
  setFormatCellTypeNumber(sheet, range) {
    let numberDecimal = 0;
    let inputArray = sheet.getArray(range.row, range.col, range.rowCount, range.colCount);
    if (!inputArray || inputArray.length <= 0) return;
    // Lặp qua từng mảng con
    for (let i = 0; i < inputArray.length; i++) {
      const subArray = inputArray[i];

      // Lặp qua từng phần tử trong mảng con
      for (let j = 0; j < subArray.length; j++) {
        try {
          const item = subArray[j].toString().trim();
          // Kiểm tra nếu phần tử là chuỗi
          if (item === null || item === undefined || item == '' || !this.isNumericStringWithCommaAndDot(item)) continue;
          let result = this.checkNumberFormatter(item);
          if (result.isNumber) {
            if (result.thousandSeperator) {
              subArray[j] = this.replaceAll(item, result.thousandSeperator, '');
            }
            if (result.decimalSeparator && result.decimalSeparator !== '.') {
              subArray[j] = this.replaceAll(item, result.decimalSeparator, '.');
            }
            subArray[j] = parseFloat(subArray[j]);
            if (numberDecimal < result.numberDecimal) {
              numberDecimal = result.numberDecimal;
            }
          }
        } catch {
          // Nếu có lỗi thì bỏ qua để dữ nguyên giá trị
          continue;
        }
      }
    }
    sheet.setArray(range.row, range.col, inputArray);
    return numberDecimal;
  }
  /**
   * kiểm tra kiểu số theo định dạng của excel
   * @param {let} value
   * @returns
   */
  checkNumberFormatter(input) {
    let result = {
      isNumber: false,
      decimalSeparator: null,
      thousandSeperator: null,
      numberDecimal: 0,
    };
    let commaCount = this.countCharacter(input, ',');
    let periodCount = this.countCharacter(input, '.');
    if (commaCount > 1 && periodCount > 1) return result;

    // lấy ra ký tự cuói cùng không phải số
    let lastNonNumericChar = this.getLastNonNumericChar(input);
    // Nếu chuỗi chứa toàn số thì trả về hợp lệ
    if (lastNonNumericChar.character === null) {
      result.isNumber = true;
      return result; // Hợp lệ
    }
    // Nếu chuỗi chứa ký tự phân cách phần ngàn và phần thập phân
    if (commaCount > 0 && periodCount > 0) {
      // Nếu ký tự phân cách phần thập phân suôt hiện 2 lần trong chuối thì không hợp lệ
      if (this.countCharacter(input, lastNonNumericChar.character) > 1) return false; // Không hợp lệ

      if (lastNonNumericChar.character === ',') {
        result.decimalSeparator = ',';
        result.thousandSeperator = '.';
      } else {
        result.decimalSeparator = '.';
        result.thousandSeperator = ',';
      }
      result.isNumber = this.splitAndCheckLength(lastNonNumericChar.slicedString, result.thousandSeperator);
      result.numberDecimal = lastNonNumericChar.remaining;
      return result;
    }

    if (lastNonNumericChar.character === ',' && commaCount == 1) {
      if (lastNonNumericChar.remaining != 3) {
        result.decimalSeparator = ',';
        result.numberDecimal = lastNonNumericChar.remaining;
      } else {
        if (lastNonNumericChar.slicedString.length <= 3) {
          result.thousandSeperator = ',';
        }
      }
      result.isNumber = true;
      return result;
    } else if (lastNonNumericChar.character === '.' && periodCount == 1) {
      if (lastNonNumericChar.remaining != 3) {
        result.decimalSeparator = '.';
        result.numberDecimal = lastNonNumericChar.remaining;
      } else {
        if (lastNonNumericChar.slicedString.length <= 3) {
          result.thousandSeperator = '.';
        }
      }
      result.isNumber = true;
      return result;
    }

    result.isNumber = this.splitAndCheckLength(input, lastNonNumericChar.character);
    result.thousandSeperator = lastNonNumericChar.character;
    return result;
  }

  /**
   * kiểm tra chuỗi có chưa ký tự khác số và dấu phẩy, dấu chấm
   * @param {string} str
   * @returns
   */
  isNumericStringWithCommaAndDot(str) {
    return /^[\d,\.]+$/.test(str);
  }

  /**
   * Hàm này tìm ký tự cuối cùng trong chuỗi không phải là số,
   * trả về đối tượng chứa ký tự đó, số ký tự còn lại sau nó,
   * và chuỗi được cắt từ đầu đến ký tự đó (bao gồm cả ký tự đó).
   * @param {string} str - Chuỗi cần kiểm tra
   * @returns {object} - Đối tượng chứa ký tự không phải số, số ký tự còn lại, và chuỗi đã cắt
   */
  getLastNonNumericChar(str) {
    // Duyệt ngược chuỗi từ ký tự cuối cùng về ký tự đầu tiên
    for (let i = str.length - 1; i >= 0; i--) {
      // Kiểm tra nếu ký tự hiện tại không phải là số
      if (isNaN(str[i])) {
        // Trả về đối tượng chứa ký tự không phải số, số ký tự còn lại và chuỗi đã cắt
        return {
          character: str[i], // Ký tự không phải số
          remaining: str.length - i - 1, // Số lượng ký tự còn lại sau ký tự đó
          slicedString: str.slice(0, i), // Chuỗi cắt từ đầu đến ký tự đó (bao gồm cả ký tự đó)
        };
      }
    }
    // Nếu không có ký tự nào không phải số trong chuỗi, trả về null và chuỗi rỗng
    return {
      character: null,
      remaining: 0,
      slicedString: '',
    };
  }

  /**
   * Đếm số lần xuất hiện của ký tự trong chuỗi
   * @param {string} str chuỗi
   * @param {char} char ký tự cần đếm
   * @returns
   */
  countCharacter(str, char) {
    return str.split(char).length - 1;
  }

  /**
   * Hàm này chuyển chuỗi thành mảng các chuỗi nhỏ qua ký tự '.'
   * và kiểm tra xem có phần tử nào trong mảng có độ dài khác 3 ký tự không
   * @param {string} str - Chuỗi cần tách
   * @param {char} char - ký tự
   * @returns {boolean} - Trả về true nếu có phần tử nào không phải 3 ký tự, ngược lại trả về false
   */
  splitAndCheckLength(str, char) {
    // Chuyển chuỗi thành mảng qua ký tự '.'
    let arr = str?.split(char);
    if (!arr) return false;
    // hàng đơn vị cuối cùng có thể nhó hơn 3
    //VD: 2.000.000 => hàng triệu chỉ có 1 (là 2)
    if (arr?.length > 0 && arr[0].length > 3) {
      return false;
    }
    arr.shift();
    // Kiểm tra nếu có phần tử nào trong mảng có độ dài khác 3 ký tự
    return !arr.some(item => item.length !== 3);
  }

  /**
   * Hàm set tag để set formatter mặc định cho cột khi thêm cột
   * Gọi ngay sau hàm render workbook
   * @param {*} wb
   * @param {*} formatType
   * @returns
   */
  setFormatterDefaultByAddColumn(wb, formatType = null) {
    let sheets = wb.sheets;
    if (!sheets || sheets.length <= 0 || !formatType) return;
    sheets.forEach(sheet => {
      let tagSheet = sheet.tag();
      if (!tagSheet) {
        tagSheet = { format: formatType };
      } else {
        tagSheet.format = formatType;
      }
    });
  }
  /**
   * render nhiều sheet dành cho thuyết minh thường tổng hợp
   * @param {*} wb
   * @param {*} dataTemplates
   * @param {*} wbComponent
   * @returns
   */
  async renderWorkbookFormultipleFile(wb, dataTemplates, wbComponent) {
    let me = this;
    if (!dataTemplates || dataTemplates == null || dataTemplates.filter(obj => obj !== null).length < 1) return;
    let numberSheets = dataTemplates.filter(obj => obj !== null).length;
    // xóa sheet thừa
    while (wb.getSheetCount() > numberSheets) {
      wb.removeSheet(0);
    }
    // add thêm sheet cần
    while (wb.getSheetCount() < numberSheets) {
      wbComponent.addSheetWb(0);
    }
    wb.suspendPaint();
    wb.suspendEvent();
    // Chỉ copy value
    wb.options.allowCopyPasteExcelStyle = true;
    wb.options.tabEditable = false;
    wb.options.allowExtendPasteRange = true;
    let nameSheet = 0;
    for (let index = 0; index < dataTemplates.length; index++) {
      const element = dataTemplates[index];
      let sheet = wb.getSheet(nameSheet);
      if (sheet) {
        sheet.reset();
        try {
          if (element && element != null && JSON.parse(element)) {
            sheet.fromJSON(JSON.parse(element), {
              doNotRecalculateAfterLoad: true,
            });
          } else {
            continue;
          }
        } catch {
          continue;
        }
        if (index == 0) {
          sheet.isSelected(true);
        } else {
          sheet.isSelected(false);
        }
        //Thêm dòng mặc định
        sheet.name('sheet ' + (index + 1).toString());
        nameSheet++;
      }
    }
    wb.resumeEvent();
    wb.resumePaint();
    me.resetSelectCellWorkbook(wb);
  }
  /**
   * Thêm comment cho workbook
   * @param {*} sheet
   * @param {*} dataColums
   * @returns
   */
  addCommentWorkbook(textComment, sheet, index) {
    if (!textComment || !sheet) return;
    let comment = new GC.Spread.Sheets.Comments.Comment();
    comment.autoSize(true);
    comment.fontFamily('Times New Roman'); // Đặt font với kiểu chữ in đậm và kích cỡ 12px
    comment.fontSize('12pt'); // Đặt font với kiểu chữ in đậm và kích cỡ 12px
    comment.padding(new GC.Spread.Sheets.Comments.Padding(8, 8, 8, 8));
    comment.backColor('#FFEFB7');
    comment.displayMode(GC.Spread.Sheets.Comments.DisplayMode.hoverShown);
    comment.indicatorColor('#ed7d31');
    comment.indicatorSize(10);
    comment.text(textComment);
    sheet.getCell(0, index).comment(comment);
  }
  /**
   * Thêm comment cho workbook
   * @param {*} sheet
   * @param {*} dataColums
   * @returns
   */
  addCommentCellWorkbook(textComment, cell) {
    if (!textComment || !cell || cell.row != 0) return;
    let comment = new GC.Spread.Sheets.Comments.Comment();
    comment.autoSize(true);
    comment.fontFamily('Times New Roman'); // Đặt font với kiểu chữ in đậm và kích cỡ 12px
    comment.fontSize('12pt'); // Đặt font với kiểu chữ in đậm và kích cỡ 12px
    comment.padding(new GC.Spread.Sheets.Comments.Padding(8, 8, 8, 8));
    comment.displayMode(GC.Spread.Sheets.Comments.DisplayMode.hoverShown);
    comment.indicatorColor('#ed7d31');
    comment.backColor('#FFEFB7');
    comment.indicatorSize(10);
    comment.text(textComment);
    cell.comment(comment);
  }

  /**
   * Chuyển đổi công thức code sang text
   * @param {*} codeString
   * @param {*} dataColums
   * @returns
   */
  mapCodeToTextFormula(textFormula, dataColums) {
    let me = this,
      defaultNames = i18nEnum.ExplanatoryGeneralFields;

    dataColums = defaultNames.map(t => { return { field_code: t.FieldCode, field_name: t.FieldName } }).concat(dataColums);

    dataColums.forEach(item => {
      textFormula = me.replaceAll(textFormula, '[' + item.field_code + ']', item.field_name);
    });
    return textFormula;
  }

  /**
   * show bảng điều kiện ngầm định
   * @param {*} wb
   * @param {*} option
   */
  showRowsTableCondition(wb, option) {
    let sheet = wb.getActiveSheet(),
      tagSheet = sheet.tag()?.headerInfo,
      columns = [],
      data = [],
      nameEntity = '',
      infoColumns = {};
    let options = {
      position: 'top',
    };
    if (!tagSheet) {
      useToast().info('Không có bảng điều kiện', options);
      return;
    }
    // Get selected range
    let rangeSelects = sheet?.getSelections();
    if (!rangeSelects || rangeSelects == null || rangeSelects.length <= 0) return;
    let indexCol = rangeSelects[0].col;
    if (tagSheet) {
      infoColumns = JSON.parse(tagSheet);
    }
    if (!infoColumns[indexCol].default_value) {
      useToast().info('Không có bảng điều kiện', options);
      return;
    }
    let dataCondition = JSON.parse(infoColumns[indexCol].default_value);
    nameEntity = infoColumns[indexCol].displayName;
    if (dataCondition && dataCondition.length > 0) {
      dataCondition.forEach((item, index) => {
        let itemData = {};
        for (let key in item) {
          if (key !== 'DefaultValue') {
            itemData[key] = item[key].join(',');
          } else {
            if (Array.isArray(key)) {
              itemData[key] = item[key].join(',');
            } else {
              itemData[key] = item.DefaultValue;
            }
          }
        }
        data.push(itemData);
      });
    }
    // Sử dụng reduce để tìm đối tượng có nhiều key nhất
    const objectWithMostKeys = dataCondition.reduce((maxObj, currentObj) => {
      return Object.keys(currentObj).length > Object.keys(maxObj).length ? currentObj : maxObj;
    }, {});

    for (let key in objectWithMostKeys) {
      if (key !== 'DefaultValue') {
        let itemColumns = {
          sortable: false,
          dataField: key,
          editable: true,
          columnType: 0,
          width: 200,
        };
        const result = infoColumns.find(item => item.name === key);
        itemColumns.title = result?.displayName;
        itemColumns.caption = result?.displayName;
        if (!result) {
          let generalFields = i18nEnum.ExplanatoryGeneralFields;
          const result = generalFields.find(item => item.FieldCode === key);
          itemColumns.title = result?.FieldName;
          itemColumns.caption = result?.FieldName;
        }
        columns.push(itemColumns);
      }
    }
    columns.push({
      caption: 'Giá trị định mức',
      title: 'Giá trị định mức',
      sortable: false,
      dataField: 'DefaultValue',
      editable: true,
      columnType: 2,
      template: 'templateShowValueTable',
      width: 200,
    });
    // show bảng điều kiện
    popupUtil.show('DescribeHelperPopup', {
      nameEntity: nameEntity,
      columns: columns,
      data: data,
    });
  }

  /**
   * Tạo ra comment cho cột
   * @param {*} item Thông tin trường dữ liệu
   * @returns
   */
  genCommentColumn(item, dataColums) {
    if (!item || !dataColums || dataColums.length <= 1) return null;
    let textComment = '';
    if (item.note) {
      textComment += '\nGhi chú: ' + item.note;
    }
    if (item.is_setting_default_value) {
      switch (item.default_type) {
        case i18nEnum.DefaultTypeNumber.ValueToFormula:
          textComment += '\n' + 'Công thức tính: ' + this.mapCodeToTextFormula(item.default_value, dataColums);
          break;
        case i18nEnum.DefaultTypeNumber.ValueToCondition:
          textComment += '\n' + 'Bấm chuột phải vào tiêu đề cột để xem bảng điều kiện ngầm định.';
          break;
      }
    }
    if (textComment != '') {
      return `Tên trường:  ${item.field_name}` + textComment;
    }
    return null;
  }
  /**
   * thêm comment cho header
   * @param {*} headerInfo thông tin header
   * @param {*} dataColums thông tin các cột dữ liệu
   */
  addCommentToHeaderInfo(headerInfo, dataColums) {
    if (headerInfo.length <= 0) return [];
    headerInfo.forEach(headerItem => {
      let item = dataColums.find(item => item.field_code === headerItem.name);
      if (item) {
        let textComment = '';
        if (item.note) {
          textComment += '\nGhi chú: ' + item.note;
        }
        if (item.is_setting_default_value) {
          switch (item.default_type) {
            case i18nEnum.DefaultTypeNumber.ValueToFormula:
              textComment += '\n' + 'Công thức tính: ' + this.mapCodeToTextFormula(item.default_value, dataColums);
              break;
            case i18nEnum.DefaultTypeNumber.ValueToCondition:
              textComment += '\n' + 'Bấm chuột phải vào tiêu đề cột để xem bảng điều kiện ngầm định.';
              headerItem.default_value = item.default_value;
              break;
          }
        }
        if (textComment != '') {
          headerItem.commentCol = `Tên trường:  ${item.field_name}` + textComment;
        }
      }
    });
    return headerInfo;
  }
  /**
   * xử lý trước ẩn hiên trước khi mở contextMenu Workbok
   * @param {*} menuData
   * @param {*} itemsDataForShown
   * @param {*} hitInfo
   * @param {*} spread
   */
  customBeforeShowContextMenu(menuData, itemsDataForShown, hitInfo, spread) {
    let sheet = spread.getActiveSheet();
    let col = hitInfo.worksheetHitInfo.col;
    let tagSheet = sheet.tag()?.headerInfo;
    const index = menuData.findIndex(item => item.id === i18nEnum.idCommandContextMenu.showRowsTableCondition);
    if (index !== -1) {
      menuData.splice(index, 1)[0];
    }
    const index1 = itemsDataForShown.findIndex(
      item => item.id === i18nEnum.idCommandContextMenu.showRowsTableCondition,
    );
    if (index1 !== -1) {
      itemsDataForShown.splice(index1, 1)[0];
    }

    if (tagSheet) {
      try {
        let infoColumns = JSON.parse(tagSheet);
        if (infoColumns[col] && infoColumns[col].default_value) {
          menuData.push(workbookHelper.contextMenuCustomExp[0]);
          itemsDataForShown.push(workbookHelper.contextMenuCustomExp[0]);
        }
      } catch {
        return;
      }
    }
  }

  // Hàm để cập nhật font cho một range
  updateFontInWorkbook(workbook) {
    // Lặp qua tất cả các sheet trong workbook
    workbook.eachSheet((sheet, sheetId) => {
      // Lặp qua tất cả các row của sheet
      sheet.eachRow((row, rowNum) => {
        // Lặp qua tất cả các cell trong row
        row.eachCell((cell, colNum) => {
          // Nếu font có thuộc tính bold hoặc italic, xóa đi
          let fontCustom = (cell.font = {
            ...cell.font, // Giữ lại các thuộc tính font khác
            bold: false, // Xóa in đậm
            italic: false, // Xóa in nghiêng
          });
          if (rowNum == 1) {
            fontCustom.bold = true;
            cell.border = {
              top: { style: 'thin', color: { argb: 'FF000000' } }, // Viền trên
              left: { style: 'thin', color: { argb: 'FF000000' } }, // Viền trái
              bottom: { style: 'thin', color: { argb: 'FF000000' } }, // Viền dưới
              right: { style: 'thin', color: { argb: 'FF000000' } }, // Viền phải
            };
          }
          if (cell.font) {
            cell.font = fontCustom;
          }
        });
      });
    });
  }

  /**
   * render nhiều sheet dành cho thuyết minh thường tổng hợp
   * @param {*} wb
   * @param {*} dataTemplates
   * @param {*} wbComponent
   * @returns
   */
  /**
   * Render nhiều sheet cho workbook từ nhiều file templates
   * Đây là phiên bản đã được sửa để giải quyết lỗi "Not supported exception" khi đặt tên sheet
   * 
   * Cơ chế lỗi và sửa lỗi:
   * 1. Vấn đề: Khi nạp template JSON vào sheet, nếu template có thuộc tính name, nó sẽ ghi đè
   *    lên tên sheet đã đặt trước đó, dẫn đến xung đột khi cố đặt lại tên.
   * 2. Giải pháp: Đặt tên sheet TRƯỚC khi nạp template, sửa đổi thuộc tính name trong template
   *    để giữ tên sheet đã đặt, và thêm lớp bảo vệ thứ hai bằng cách đặt lại tên sau khi nạp.
   * 
   * Lưu ý: Mặc dù log vẫn có thể hiển thị lỗi (do cấu trúc dữ liệu nội bộ phức tạp của SpreadJS),
   * nhưng sheet vẫn hiển thị đúng tên nhờ metadata nội bộ đã được cập nhật.
   * 
   * @param {Object} wb - Workbook cần render
   * @param {Array} dataTemplates - Mảng dữ liệu template cho mỗi sheet
   * @param {Object} wbComponent - Component workbook để thêm sheet mới
   * @returns {void}
   * @author NMQuang - 5/22/2025 - Sửa lỗi "Not supported exception"
   */
  async renderWorkbookFormultipleFileEstInitial(wb, dataTemplates, wbComponent) {
    let me = this;
    if (!dataTemplates || dataTemplates == null || dataTemplates.filter(obj => obj !== null).length < 1) return;
    let numberSheets = dataTemplates.filter(obj => obj !== null).length;
    // xóa sheet thừa
    while (wb.getSheetCount() > 0) {
      wb.removeSheet(0);
    }
    // add thêm sheet cần
    let indexAdd = 0;
    while (wb.getSheetCount() < numberSheets) {
      wbComponent.addSheetWb(indexAdd);
      indexAdd++;
    }
    wb.suspendPaint();
    wb.suspendEvent();
    // Chỉ copy value
    wb.options.allowCopyPasteExcelStyle = true;
    wb.options.tabEditable = false;
    wb.options.allowExtendPasteRange = true;
    let nameSheet = 0;
    for (let index = 0; index < dataTemplates.length; index++) {
      const element = dataTemplates[index];
      let sheet = wb.getSheet(nameSheet);
      
      if (sheet) {
        //Thêm dòng mặc định
        let sheetName = element.sheet_name ? element.sheet_name : 'Sheet' + (index + 1).toString();
        
        // Reset sheet
        // sheet.reset();
        console.log('sheetName', sheet.name());
        // ĐẶT TÊN SHEET TRƯỚC KHI NẠP TEMPLATE
        try {
          sheet.name(sheetName);
          element.sheet_name = sheetName; // Cập nhật biến sheet_name
        } catch (nameError) {
          console.error('Lỗi khi đặt tên sheet:', nameError, sheetName);
          // Nếu thất bại, vẫn tiếp tục với tên mặc định của sheet
        }
        
        // Xử lý template
        try {
          if (element && element != null && element.template) {
            let templateData;
            try {
              templateData = JSON.parse(element.template);
              
              // Sửa đổi template để giữ tên sheet
              if (templateData.name) {
                templateData.name = sheetName;
              }
              
              sheet.fromJSON(templateData, {
                doNotRecalculateAfterLoad: true,
              });
            } catch (parseError) {
              console.error('Lỗi khi xử lý template:', parseError);
            }
          }
          
          // Thiết lập selected state
          if (index == 0) {
            sheet.isSelected(true);
          } else {
            sheet.isSelected(false);
          }
          
          // ĐẶT LẠI TÊN SAU KHI NẠP TEMPLATE để đảm bảo
          try {
            sheet.name(sheetName);
          } catch (nameError2) {
            console.error('Không thể đặt lại tên sheet sau khi nạp template:', nameError2);
            // Không cần fallback ở đây vì đã cố gắng đặt tên ở trước
          }
          
          nameSheet++;
        } catch (generalError) {
          console.error('Lỗi chung khi xử lý sheet:', generalError);
          nameSheet++;
          continue;
        }
      }
    }
    wb.resumeEvent();
    wb.resumePaint();
    me.resetSelectCellWorkbook(wb);
  }

/**
 * Hàm phân tích và tính toán công thức từ chuỗi
 * @param {object} estimateExplanationDatas Dữ liệu thuyết minh
 * @param {string} formula Chuỗi công thức cần tính toán
 * @param {object} wb Đối tượng workbook chứa các sheet
 * @returns {number} Kết quả tính toán
 */
  calcNumberByFormula(estimateExplanationDatas, formula, wb, isEdit = false, keyAmount = 'estimate_amount') {
    try {
      if (!formula || !wb) {
        return 0;
      }

      console.log("Xử lý công thức:", formula);

      // Nếu trong chế độ chỉnh sửa và có estimateExplanationDatas, tìm các sheet được tham chiếu
      if (isEdit && estimateExplanationDatas && estimateExplanationDatas.value) {
        // Trích xuất tất cả các tham chiếu sheet từ công thức
        const referencedSheets = new Set();
        // Regex cập nhật để tìm tất cả nội dung trong dấu ngoặc vuông
        const extractSheetRegex = /\[([^\]]+)\]/g;
        let sheetMatch;
        
        // Thu thập tất cả các sheet được tham chiếu
        while ((sheetMatch = extractSheetRegex.exec(formula)) !== null) {
          const fullRef = sheetMatch[1]; // Ví dụ: C422_K011_TCTK0001.01.E2
          
          // Tìm dấu chấm cuối cùng trong reference
          const dotLastIndex = fullRef.lastIndexOf(".");
          
          // Nếu không tìm thấy dấu chấm, bỏ qua reference này
          if (dotLastIndex === -1) {
            console.warn(`Reference không có dấu chấm: ${fullRef}`);
            continue;
          }
          
          // Lấy phần sau dấu chấm cuối cùng - đây nên là cell reference
          const potentialCellRef = fullRef.substring(dotLastIndex + 1);
          
          // Kiểm tra nếu phần sau dấu chấm là cell reference hợp lệ
          const cellRefRegex = /^[A-Z]+[0-9]+$/;
          if (!cellRefRegex.test(potentialCellRef)) {
            console.warn(`Cell reference không hợp lệ: ${potentialCellRef}`);
            continue;
          }
          
          // Lấy sheet name là tất cả phần trước dấu chấm cuối cùng
          const sheetName = fullRef.substring(0, dotLastIndex).trim();
          console.log(`Tìm thấy tham chiếu đến sheet: "${sheetName}", cell: "${potentialCellRef}"`);
          
          referencedSheets.add(sheetName);
        }
        
        // Reset formula và estimate_amount cho các sheet không được tham chiếu
        estimateExplanationDatas.value.forEach(item => {
          const sheetName = item.sheet_name?.trim();
          if (!referencedSheets.has(sheetName)) {
            item.formula = null;
            item[keyAmount] = 0;
          }
        });
      }

      // Chuẩn bị biểu thức để tính toán
      let expression = formula.trim();

      // Chuẩn hóa các toán tử để đảm bảo có khoảng cách đúng
      expression = expression
        .replace(/\s*\+\s*/g, ' + ')
        .replace(/\s*\-\s*/g, ' - ')
        .replace(/\s*\*\s*/g, ' * ')
        .replace(/\s*\/\s*/g, ' / ')
        .replace(/\s*\(\s*/g, ' ( ')
        .replace(/\s*\)\s*/g, ' ) ')
        .replace(/\s+/g, ' ')
        .trim();

      // Tạo bản sao của expression để thay thế các tham chiếu
      let evaluableExpression = expression;

      // Regex cập nhật để tìm tất cả nội dung trong dấu ngoặc vuông
      const fullRefRegex = /\[([^\]]+)\]/g;
      let fullMatch;

      // Tìm và thay thế tất cả các tham chiếu ô
      while ((fullMatch = fullRefRegex.exec(expression)) !== null) {
        const fullRef = fullMatch[1]; // Ví dụ: C422_K011_TCTK0001.01.E2
        const completeMatch = fullMatch[0]; // Tham chiếu đầy đủ [C422_K011_TCTK0001.01.E2]
        
        // Tìm dấu chấm cuối cùng trong reference
        const dotLastIndex = fullRef.lastIndexOf(".");
        
        // Nếu không tìm thấy dấu chấm, bỏ qua reference này
        if (dotLastIndex === -1) {
          console.error(`Reference không có dấu chấm: ${fullRef}`);
          continue;
        }
        
        // Lấy phần sau dấu chấm cuối cùng - đây nên là cell reference
        const potentialCellRef = fullRef.substring(dotLastIndex + 1);
        
        // Kiểm tra nếu phần sau dấu chấm là cell reference hợp lệ
        const cellRefRegex = /^[A-Z]+[0-9]+$/;
        if (!cellRefRegex.test(potentialCellRef)) {
          console.error(`Cell reference không hợp lệ: ${potentialCellRef}`);
          continue;
        }
        
        // Lấy sheet name là tất cả phần trước dấu chấm cuối cùng
        const sheetName = fullRef.substring(0, dotLastIndex).trim();
        
        // Lấy giá trị từ workbook
        let cellValue = 0;
        try {
          const sheet = wb.getSheetFromName(sheetName);
          if (sheet) {
            let infoCell = this.excelCellToNum(potentialCellRef);
            let rawValue = sheet.getValue(infoCell.row, infoCell.col);

            // Đảm bảo chuyển đổi sang số đúng cách
            cellValue = !isNaN(parseFloat(rawValue)) ? parseFloat(rawValue) : 0;
            console.log(`Tham chiếu ${sheetName}.${potentialCellRef} có giá trị: ${cellValue}`);

            // Cập nhật giá trị vào estimateExplanationDatas nếu có
            if (isEdit) {
              if (estimateExplanationDatas && estimateExplanationDatas.value) {
                let itemSheet = estimateExplanationDatas.value.find(item =>
                  item.sheet_name === sheetName || item.sheet_name?.trim() === sheetName
                );
                if (itemSheet) {
                  itemSheet.formula = potentialCellRef;
                  itemSheet[keyAmount] = cellValue;
                }
              }
            }
          } else {
            console.error(`Không tìm thấy sheet: ${sheetName}`);
          }
        } catch (e) {
          console.error(`Lỗi khi truy cập ô ${sheetName}.${potentialCellRef}:`, e, e.stack);
        }

        // Thay thế tham chiếu bằng giá trị số, bảo đảm không phá vỡ cú pháp
        evaluableExpression = evaluableExpression.replace(completeMatch, `(${cellValue})`);
      }

      // Kiểm tra biểu thức có hợp lệ không
      // Tìm các mẫu không hợp lệ như ))( hoặc )(
      const invalidPatterns = /\)\s*\(/g;
      if (invalidPatterns.test(evaluableExpression)) {
        console.error('Lỗi cú pháp trong biểu thức: thiếu toán tử giữa các tham chiếu');
        return 0;
      }

      try {
        // Log biểu thức trước khi tính toán để dễ gỡ lỗi
        console.log('Biểu thức sẽ tính toán:', evaluableExpression);

        // Tạo hàm đánh giá biểu thức
        const calculatedResult = new Function(`return ${evaluableExpression}`)();

        // Đảm bảo kết quả là số
        const numericResult = !isNaN(calculatedResult) ? Number(calculatedResult) : 0;
        return numericResult;
      } catch (e) {
        console.error('Lỗi khi tính toán biểu thức:', e, 'Biểu thức:', evaluableExpression);
        return 0;
      }
    } catch (e) {
      console.error('Lỗi trong calcNumberByFormula:', e);
      return 0;
    }
  }

/**
 * Hàm tách sheet lưu cho nhiều biểu thuyết minh STORAGE
 * @param {*} wb
 * @param {*} estFormDatas
 */

  uploadMultipleTemplateStorage(wb, estFormDatas, upLoadFile, options = { keyFileName: 'estimate_storage_explanation_id', keyListId: 'estInitialId' }) {
    let arrayestForm = [];
    if (estFormDatas.length == 1) {
      arrayestForm.push({
        file: JSON.stringify(wb.getActiveSheet().toJSON()),
        fileName: estFormDatas[0][options.keyFileName],
        url: estFormDatas[0][options.keyListId] ? estFormDatas[0][options.keyListId] : null,
      });
    }
    else {
      estFormDatas.forEach(item => {
        arrayestForm.push({
          file: JSON.stringify(wb.getSheetFromName(item.sheet_name)?.toJSON()),
          fileName: item[options.keyFileName],
          url: item[options.keyListId] ? item[options.keyListId] : null,
        });
      });
    }
    if (upLoadFile && typeof upLoadFile === 'function') {
      upLoadFile(arrayestForm);
    }
  }

  /**
 * Hàm tách sheet lưu cho nhiều biểu thuyết minh STORAGE
 * @param {*} wb
 * @param {*} estFormDatas
 */

  uploadMultipleSectorWideTemplateStorage(wb, estFormDatas, upLoadFile, options = { keyFileName: 'est_initial_aggregate_storage_explanation_id', keyListId: 'estInitialId' }) {
    let arrayestForm = [];
    if (estFormDatas.length == 1) {
      arrayestForm.push({
        file: JSON.stringify(wb.getActiveSheet().toJSON()),
        fileName: estFormDatas[0][options.keyFileName],
        url: estFormDatas[0][options.keyListId] ? estFormDatas[0][options.keyListId] : null,
      });
    }
    else {
      estFormDatas.forEach(item => {
        arrayestForm.push({
          file: JSON.stringify(wb.getSheetFromName(item.sheet_name)?.toJSON()),
          fileName: item[options.keyFileName],
          url: item[options.keyListId] ? item[options.keyListId] : null,
        });
      });
    }
    if (upLoadFile && typeof upLoadFile === 'function') {
      upLoadFile(arrayestForm);
    }
  }

  /**
   * Gán các công thức vào workbook
   * @param {Object} workbook - Đối tượng workbook
   * @param {Array} formulas - Mảng các công thức cần gán
   */
  appendFormulasToWorkbook(workbook, formulas) {
    if (!workbook || !formulas || !Array.isArray(formulas)) {
      return;
    }
    
    try {
      // Tạm dừng event và paint để tăng hiệu năng
      workbook.suspendEvent();
      workbook.suspendPaint();
      
      formulas.forEach(item => {
        try {
          // Lấy sheet theo tên
          const sheet = workbook.getSheetFromName(item.sheet_name);
          
          if (sheet) {
            // Phân tích vị trí ô từ cell_name (ví dụ: A1, E4)
            const colRow = this.excelCellToNum(item.cell_name);
            
            if (colRow) {
              // Đặt giá trị cho ô
              sheet.setText(colRow.row, colRow.col, item.formula);
            }
          }
        } catch (error) {
          console.error(`Lỗi khi gán công thức cho ô ${item.cell_name} tại sheet ${item.sheet_name}:`, error);
        }
      });
    } finally {
      // Khôi phục event và paint sau khi hoàn thành
      workbook.resumePaint();
      workbook.resumeEvent();
    }
  }
}

export default new MISAExplanationFormHelper();
